<template>
  <div class="list-wrapper">
    <el-container style="height: 100%">
      <el-main
        style="display: flex;flex-direction:column;justify-content: space-between;padding: 0;"
      >
        <div class="content">
          <template v-if="!singleDiagnose">
            <div class="header">

              <span style="margin-right:10px;margin-left:15px;font-size:18px;font-weight:bold;"><h2>筛选词:</h2></span>
              <span style="margin-right:10px;margin-left:15px;">诊疗类型:</span>
              <el-select clearable style="width: 115px"  @change="searchName" v-model="diagnosis_type"
                          placeholder="请选择">
                <el-option
                  v-for="item in diagnosisTypeList"
                  :key="item.key"
                  :label="item.val"
                  :value="item.key"
                >
                </el-option>
              </el-select>

              <span style="margin-right:10px; margin-left:10px;">   患者信息:</span>
              <el-input
                style="width:200px;margin-right:20px"
                placeholder="ID/姓名/手机号"
                prefix-icon="el-icon-search"
                v-model="keywordString"
                clearable
                @change="searchName"
              ></el-input>
              <!-- <el-select
                placeholder="类别"
                @change="chioceType"
                v-model="typeSearch"
                style="width:120px;margin-right:20px"
              >
                <el-option
                  v-for="item in typeOptinon"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>-->
              <span style="margin-right:10px;">年龄:</span>
              <el-input
                placeholder="从"
                v-model="startAge"
                style="width:80px;margin-right:20px;"
                @change="searchName"
                clearable
              ></el-input>
              <span style="margin-right:20px;">-</span>
              <el-input
                placeholder="至"
                v-model="endAge"
                style="width:80px;margin-right:20px;"
                @change="searchName"
                clearable
              ></el-input>
              
              <span style="margin-right:10px;">患者创建时间:</span>
              <el-date-picker
                style="margin-right: 20px;width: 21%"
                v-model="sDate"
                clearable
                type="datetimerange"
                range-separator="至"
                @change="searchName"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              

              
              <div class="space"></div>
              <button
                class="btn iconfont createPatients"
                style="padding: 0; margin-right:10px; width:80px"                
                @click.prevent="searchName"
              >刷    新</button>
              
              <button
                class="btn iconfont createPatients btn_newpatient"
                style="padding:0;margin-right:10px;width:100px"
                @click.prevent="newPatient"
              >添加患者</button>
              <!-- <button :disabled="followup_disabled"
                class="btn iconfont createPatients"
                style="padding:0;width:110px; background-color:rgb(17, 187, 170)"
                @click.prevent="newFollowup"
              >加入随访({{checkedNum}})</button> -->
            </div>
            <!-- 数据加载提示 -->
            <div style="height: 100%" 
              v-loading="getPatientListLoading"
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.4)"
            >
            <ul class="patient-list">
              <li class="list-header">
                <div style="display: flex;flex: 1">
                  <span style="width:4%">序号</span>
                  <!-- <span style="width:8%">历史诊断</span> -->
                  <span style="width:8%" class="tableTitle" @click="order('id')">
                    ID
                    <i class="iconfont icon-paixu1"></i>
                  </span>
                  <span style="width:9%" class="tableTitle" @click="order('name')">
                    姓名
                    <i class="iconfont icon-paixu1"></i>
                  </span>
                  <span style="width:5%">性别</span>
                  <span style="width:5%">年龄</span>
                  <!-- <span style="width:10%">民族</span> -->
                  <span style="width:11%" class="tableTitle" @click="order('update_time')">
                    更新时间
                    <i class="iconfont icon-paixu1"></i>
                  </span>
                  <span style="width:11%" class="tableTitle" @click="order('created_time')">
                    患者创建时间
                    <i class="iconfont icon-paixu1"></i>
                  </span>

                  <span style="width:12%" class="tableTitle" @click="">
                    最新诊断
                  </span>
                  <span style="width:7%" class="tableTitle" @click="">
                    报告状态
                  </span>
                  <span v-acl="['gen_online_report']" style="width:8%" class="tableTitle" @click="">
                    云胶片状态
                  </span>
                  <span style="width:25%">
                    操作
                  </span>
                </div>
                <span style="width: 26px"></span>
              </li>
              <!-- @change="changeHandler" -->
              <!-- @cell-click='changeHandler(row, column, cell, event)' -->
              <el-collapse @change="changeHandler" v-model="activeName" accordion>
                <el-collapse-item v-for="(item,index) in patients" :key="index" :name="item.id">
                  <template slot="title">
                    <li style="width:100%" class="list-content">
                      <div class="list-item">
                        <span style="width:4%">{{index+1}}</span>
                        <!-- <span style="width:8%;font-size:24px" @click="showHid(index,item.id)">
                                <i class="el-icon-tickets"></i>
                        </span>-->
                        <span
                          style="width:8%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 10px;box-sizing: border-box"
                        >{{item.id_in_hospital ? item.id_in_hospital : item.id}}</span>
                        <span
                          style="width:9%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 10px;box-sizing: border-box"
                        >{{item.name}}</span>
                        <span style="width:4%">{{item.gender}}</span>
                        <span style="width:4%">{{item.showAge}}</span>
                        <!-- <span style="width:10%">{{item.race}}</span> -->
                        <!-- <span
                          style="width:20%"
                          v-if="item.last_diagnosis"
                        >{{item.last_diagnosis.time | formatTime}}</span>-->
                        <span style="width:11%">{{item.update_time}}</span>
                        <span style="width:11%">{{item.created_time}}</span>
                        <span
                          style="width:12%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 10px;
                          box-sizing: border-box">{{item.last_diagnosis_text}}
                        </span>
                        <span style="width:7%" :class="{no_print: item.printStatus === '未打印'}">
                          {{item.printStatus}}
                        </span>
                        <span   v-acl="['gen_online_report']"  style="width:8%" :class="{online_report_error: item.onlineReportStatus===-1, online_report_regular: item.onlineReportStatus===0, online_report_note: item.onlineReportStatus===1 }" >
                          {{item.online_report_state}}
                        </span>
                        <span style="width:27%;z-index:999">                         
                          <el-button
                            v-acl="['diagnoses_image']"
                            @click.stop="newDiagnose($event,item)"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 46px;display:inline-block;"
                          >影像<el-badge is-dot type="warning" v-show="item.diagnosesNum.diagnoses>0"></el-badge>
                          </el-button>
                          
                          <el-button
                            v-acl="['operation_order']"
                            @click.stop="newOperation($event,item)"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 46px;display:inline-block;"
                          >手术<el-badge is-dot type="warning" v-show="item.diagnosesNum.operation>0"></el-badge>
                          </el-button>
                          <el-button
                            v-acl="['inhospital_order']"
                            @click.stop="newInHospotal($event,item)"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 46px;display:inline-block;"
                          >住院<el-badge is-dot type="warning" v-show="item.diagnosesNum.inHospital>0"></el-badge>
                          </el-button>
                          <el-button
                            v-acl="['export_cosmetology']"
                            @click.stop="newCosmetology($event,item)"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 66px;display:inline-block;"
                          >美容/治疗<el-badge is-dot type="warning"  v-show="item.diagnosesNum.cosmetology>0"></el-badge>
                          </el-button>
                          <el-button
                            v-acl="['sd_vitiligo']"
                            @click.stop="newVitiligo($event,item)"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 54px;display:inline-block;"
                          >白癜风<el-badge is-dot type="warning"  v-show="item.diagnosesNum.vitiligoBasicInfo>0"></el-badge>
                          </el-button>
                          <el-button
                            v-acl="['sd_mm']"
                            @click.stop="newMm($event,item)"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 54px;display:inline-block;"
                          >黑素瘤<el-badge is-dot type="warning"  v-show="item.diagnosesNum.mmBasicInfo>0"></el-badge>
                          </el-button>
                          <el-button
                            @click.stop="showRevise($event,item.id)"
                            size="mini"
                            type="primary"
                            icon="el-icon-edit"
                            class="btn"
                            style="width: 40px;display:inline-block;"
                          ></el-button>
                        </span>
                      </div>
                    </li>
                  </template>
                  <div class="list-hid" v-if="resultArr.length>0">
                    <div ref="mySwiper" class="firstShow">
                      <div
                        v-for="(ele,index2) in resultArr[0]"
                        :key="index2"
                        class="check-box"
                        :style="{'background':background(ele.typeDignoses)}"
                      >
                        <span class="card-type-badge" :style="{'background':typeBadgeColor(ele.typeDignoses)}">{{typeBadge(ele.typeDignoses)}}</span>
                        <div
                          @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                          v-if="ele.typeDignoses=='影像'"
                          class="check-box2"
                        >
                          <div class="imgBack cardImg">
                            <template v-if="ele.images.length > 0">
                              <img
                                :src="imageSrcPrefixThumbnails +ele.images[0].path"
                                alt
                                class="checkBoxImg"
                                :class="{'heightAuto':ele.images[0].width<ele.images[0].height,'widthAuto':ele.images[0].width>=ele.images[0].height}"
                              />
                            </template>
                          </div>
                          <div class="check-info">
                            <p>
                              检查时间:
                              <span>{{ele.time}}</span>
                            </p>
                            <p style="display: flex;justify-content: space-between">
                              <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                                检查编号:
                                <span>{{ele.id_in_hospital}}</span>
                              </span>
                              <span
                                class="iconfont"
                                style="color: rgb(255,68,0);cursor: default"
                                v-if="ele.isPrintReport"
                                title="未打印报告"
                                @click.stop=""
                              >&#xe62b;</span>
                            </p>
                            
                            <p class="ellipsisP">
                              检查部位:
                              <span class="ellipsisSpan ellipsis">{{ele.position_detail_list}}</span>
                            </p>
                            <template v-if="ele.doctor_conclusion">
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p class="ellipsisP">
                                  结果:
                                  <span
                                    class="ellipsis ellipsisSpan"
                                  >{{ele.doctor_conclusion | formatConclusion}}</span>
                                </p>
                                <div
                                  class="iconfont modify-btn"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑诊断"
                                  v-acl="['diagnoses_image']"
                                  @click.stop="modifyDiagnosis(ele.id)"
                                  v-if="isShowModifyDiagnosisBtn(ele.time) && ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  v-acl="['diagnoses_image']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  v-else
                                  @click.stop
                                >&#xe630e;</div>
                                <div class="iconfont" v-acl="['gen_online_report']" @click.stop="showOnlineReport(ele.id)">  
                                  <img src="../assets/online_report.png" style="width: 17px;height:15px;margin-left:15px;margin-top:2px" />
                                </div>
                                

                              </div>
                            </template>
                            <template v-else>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p>
                                  结果:
                                  <span></span>
                                </p>
                                <div
                                  v-acl="['diagnoses_image']"
                                  class="iconfont modify-btn"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑诊断"
                                  @click.stop="modifyDiagnosis(ele.id)"
                                  v-if="isShowModifyDiagnosisBtn(ele.time) && ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  v-acl="['diagnoses_image']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  v-else
                                  @click.stop
                                >&#xe630e;</div>
                                <div class="iconfont" v-acl="['gen_online_report']" @click.stop="showOnlineReport(ele.id)">  
                                  <img src="../assets/online_report.png" style="width: 17px;height:15px;margin-left:15px;margin-top:2px" />
                                </div>
                                
                              </div>
                            </template>
                          </div>
                        </div>
                        <div
                          @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                          v-if="ele.typeDignoses=='美容'"
                          class="check-box2"
                        >
                          <div class="imgBack cardImg">
                            <template v-if="ele.image_cosmetology.length > 0">
                              <img
                                :src="imageSrcPrefixThumbnails2 +ele.image_cosmetology[0].path"
                                alt
                                class="checkBoxImg"
                                :class="{'heightAuto':ele.image_cosmetology[0].width<ele.image_cosmetology[0].height,'widthAuto':ele.image_cosmetology[0].width>=ele.image_cosmetology[0].height}"
                              />
                            </template>
                          </div>
                          <div class="check-info">
                            <p
                              style="display: flex;justify-content: space-between"
                              :title="ele.title"
                            >
                              <span class="cosmetology">
                                项目:
                                <span>{{ele.title}}</span>
                              </span>
                            </p>
                            <p class="cosmetology">
                              创建时间:
                              <span>{{ele.time}}</span>
                            </p>
                            <p class="ellipsisP cosmetology">
                              次数:
                              <span
                                class="ellipsisSpan ellipsis"
                              >第{{ele.leftNum}}次/共{{ele.total}}次</span>
                            </p>
                            <template v-if="true">
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p class="ellipsisP cosmetology">
                                  备注:
                                  <span class="ellipsis ellipsisSpan">{{ele.remarks}}</span>
                                </p>
                                <div
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑美容"
                                  v-acl="['export_cosmetology']"
                                  @click.stop="modifyCosmetology(ele)"
                                  v-if="ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  v-acl="['export_cosmetology']"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div>
                              </div>
                            </template>
                            <!-- <template v-else>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p>
                                  结果:
                                  <span></span>
                                </p>
                                <div
                                v-acl="['diagnoses_image']"
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑诊断"
                                  @click.stop="modifyDiagnosis(ele)"
                                  v-if="isShowModifyDiagnosisBtn(ele.time)"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont" v-acl="['diagnoses_image']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  v-else
                                  @click.stop=""
                                >&#xe630e;</div>
                              </div>
                            </template>-->
                          </div>
                        </div>
                        <div
                          @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                          class="check-box2 inHospitalCard"
                          v-if="ele.typeDignoses=='住院'"
                        >
                          <div class="imgBack cardImg">
                            <template v-if="ele.image_hospitalization.length > 0">
                              <img
                                :src="hospitalization_imagesThumbnails
                            +ele.image_hospitalization[ele.image_hospitalization.length - 1].path"
                                alt
                                class="checkBoxImg"
                                :class="{'heightAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width<ele.image_hospitalization[ele.image_hospitalization.length - 1].height,'widthAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width>=ele.image_hospitalization[ele.image_hospitalization.length - 1].height}"
                              />
                            </template>
                          </div>
                          <div class="check-info">
                            <p>
                              记录时间:
                              <span>{{ele.update_time}}</span>
                            </p>
                            <p>
                              病程及诊断:  
                              <span>{{ele.disease_course}};</span>                            
                              <span>{{ele.diagnosis | formatConclusion}}</span>                              
                            </p>     
                            <p class="ellipsisP">
                              病情:
                              <span class="ellipsis ellipsisSpan">{{ele.curative_effect}}</span>
                            </p>                      
                            <!-- <p>
                              入院时间:
                              <span>{{ele.inpat_date}}</span>
                            </p> -->
                            <!-- <p>
                              出院时间:
                              <span>{{ele.outpat_date}}</span>
                            </p> -->
                            <!-- <p class="ellipsisP">
                              诊断:
                              <span
                                class="ellipsisSpan ellipsis"
                              >{{ele.diagnosis | formatConclusion}}</span>
                            </p> -->
                            <template>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p class="ellipsisP">
                                  备注:
                                  <span class="ellipsis ellipsisSpan">{{ele.remarks}}</span>
                                </p>
                                <div
                                  class="iconfont"
                                  v-acl="['inhospital_order']"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑住院信息"
                                  @click.stop="getInHospital(ele.id,item)"
                                  v-if="ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  v-acl="['inhospital_order']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div
                          @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                          v-if="ele.typeDignoses=='手术'"
                          class="check-box2 operation"
                        >
                          <div
                            class="imgBack cardImg"
                            :style="`background-image: url(${operationDoctor})`"
                            style="background-size: contain;background-position: center center;background-repeat:  no-repeat;background-color: rgb(246,246,246)"
                          ></div>
                          <div class="check-info">
                            <p>
                              手术时间:
                              <span>{{ele.operation_date | formatTime1}}</span>
                            </p>
                            <p>
                              手术名称:
                              <span>{{ele.operation_name}}</span>
                            </p>
                            <p class="ellipsisP">
                              手术部位:
                              <span
                                class="ellipsisSpan ellipsis"
                              >&nbsp{{ele.operation_position}}</span>
                            </p>
                            <template v-if="ele.doctor_conclusion">
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p class="ellipsisP">
                                  手术医生:
                                  <span
                                    class="ellipsis ellipsisSpan"
                                  >&nbsp{{ele.operation_doctor}}</span>
                                </p>
                                <div
                                  v-acl="['operation_order']"
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑手术信息"
                                  @click.stop="getOperationl(ele,item)"
                                  v-if="ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  v-acl="['operation_order']"
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="编辑手术信息"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div>
                              </div>
                            </template>
                            <template v-else>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p>
                                  诊断结果:
                                  <span
                                    :title="ele.relevant_info[0].diagnosis | formatConclusion"
                                  >{{ele.relevant_info[0].diagnosis | formatConclusion}}</span>
                                </p>
                                <div
                                  v-acl="['operation_order']"
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑手术信息"
                                  @click.stop="getOperationl(ele,item)"
                                  v-if="ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  v-acl="['operation_order']"
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="编辑手术信息"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div>
                              </div>
                            </template>
                          </div>
                        </div>

                        <div
                          @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                          class="check-box2 inHospitalCard"
                          v-if="ele.typeDignoses=='白癜风基础'"
                        >
                          <div class="imgBack cardImg">
                            <!-- <template v-if="ele.image_hospitalization.length > 0">
                              <img
                                :src="hospitalization_imagesThumbnails
                            +ele.image_hospitalization[ele.image_hospitalization.length - 1].path"
                                alt
                                class="checkBoxImg"
                                :class="{'heightAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width<ele.image_hospitalization[ele.image_hospitalization.length - 1].height,'widthAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width>=ele.image_hospitalization[ele.image_hospitalization.length - 1].height}"
                              />
                            </template> -->
                          </div>
                          <div class="check-info">
                            <p>
                              记录时间:
                              <span> {{ele.visit_date}}</span>
                            </p>
                            <p>
                              类型及病程:  
                              <span> {{ele.vitiligo_type}};</span>                            
                              <span >{{(ele.duration_months&&ele.duration_months>0)?ele.duration_months+'月':'无'}}</span>                              
                            </p>     
                            <p class="ellipsisP">
                              现部位:
                              <span class="ellipsis ellipsisSpan"> {{ele.current_location}}</span>
                            </p>                      
                            <p class="ellipsisP">
                              BAS评分:
                              <span> {{ele.bsa_score}}</span>
                            </p>

                            <!-- <p class="ellipsisP">
                              诊断:
                              <span
                                class="ellipsisSpan ellipsis"
                              >{{ele.diagnosis | formatConclusion}}</span>
                            </p> -->
                            <template>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <!-- <p class="ellipsisP">
                                  备注:
                                  <span class="ellipsis ellipsisSpan">{{ele.remark1}}|{{ele.remark2}}|{{ele.remark3}}</span>
                                </p> -->
                                <p class="ellipsisP">
                                  用药:
                                  <span> {{ele.topical_medication}}</span>
                                </p>
                                <div
                                  class="iconfont"
                                  v-acl="['sd_vitiligo']"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑信息"
                                  @click.stop="getVitiligo(ele.id,item)"
                                  v-if="ele.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  v-acl="['sd_vitiligo']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div>
                              </div>
                            </template>
                          </div>
                        </div>

                        <div
                          
                          class="check-box2 inHospitalCard"
                          v-if="ele.typeDignoses=='黑色素瘤'"
                        >
                          <!-- @click="getInfo(ele.id,item.id,ele.typeDignoses)" -->
                          <div class="imgBack cardImg">
                          </div>
                          <div class="check-info">
                            <p>
                              记录时间:
                              <span> {{ele.visit_date}}</span>
                              <span v-if="ele.baseline===1" class="baseline-badge">基线</span>
                            </p>
                            <p class="ellipsisP">
                              原发部位:
                              <span class="ellipsis ellipsisSpan"> {{ele.primary_site}}</span>
                            </p>
                            <p class="ellipsisP">
                              AJCC8分期:
                              <span> {{ele.ajcc8_clinical_stage}}</span>
                            </p>
                            <p class="ellipsisP">
                              手术方式:
                              <span class="ellipsis ellipsisSpan"> {{ele.method_of_first_surgery}}</span>
                            </p>
                            <template>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: flex-end"
                              >
                                <!-- v-if="ele.isedit === 1" 此处点击总是进入对话框，但是会根据isedit状态判断是否可编辑-->
                                <div
                                  class="iconfont"
                                  v-acl="['sd_mm']"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                  title="编辑信息"
                                  @click.stop="getMm(ele.id, ele.isedit===1, item)"
                                >&#xe630e;</div>
                                <!-- <div
                                  class="iconfont"
                                  v-acl="['sd_mm']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div> -->
                              </div>
                            </template>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div v-if="!showall" class="getMore" @click="showAll">显示全部</div>
                    <div v-if="showall" class="moreShow">
                      <div v-for="(ele,index2) in moreResultArr" :key="index2" class="moreItem">
                        <div
                          v-for="(innerItem, index) in ele"
                          :key="index"
                          class="check-box"
                          :style="{'background':background(innerItem.typeDignoses)}"
                        >
                          <span class="card-type-badge" :style="{'background':typeBadgeColor(innerItem.typeDignoses)}">{{typeBadge(innerItem.typeDignoses)}}</span>
                          <div
                            v-if="innerItem.typeDignoses=='影像'"
                            class="check-box2"
                            @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                          >
                            <div class="imgBack cardImg">
                              <template v-if="innerItem.images.length > 0">
                                <template v-for="(imgItem, imgIndex) in innerItem.images">
                                  <img
                                    :src="imageSrcPrefixThumbnails + imgItem.path"
                                    :key="imgIndex"
                                    v-if="imgIndex === 0"
                                    alt
                                    class="checkBoxImg"
                                    :class="{'heightAuto': imgItem.width<imgItem.height,'widthAuto': imgItem.width>=imgItem.height}"
                                  />
                                </template>
                              </template>
                            </div>
                            <div class="check-info">
                              <p>
                                检查时间:
                                <span>{{innerItem.time}}</span>
                              </p>
                              <p style="display: flex;justify-content: space-between">
                                <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                                  检查编号:
                                  <span>{{innerItem.id_in_hospital}}</span>
                                </span>
                                <span
                                  class="iconfont"
                                  style="color: rgb(255,68,0);cursor: default"
                                  v-if="innerItem.isPrintReport"
                                  title="未打印报告"
                                  @click.stop=""
                                >&#xe62b;</span>
                              </p>

                              <p class="ellipsisP">
                                检查部位:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >{{innerItem.position_overview_list}}-{{innerItem.position_detail_list}}</span>
                              </p>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p class="ellipsisP">
                                  结果:
                                  <span
                                    v-if="innerItem.doctor_conclusion"
                                    class="ellipsis ellipsisSpan"
                                  >{{innerItem.doctor_conclusion | formatConclusion}}</span>
                                </p>
                                <div
                                  class="iconfont"
                                  v-acl="['diagnoses_image']"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold"
                                  title="编辑诊断"
                                  @click.stop="modifyDiagnosis(innerItem.id)"
                                  v-if="isShowModifyDiagnosisBtn(innerItem.time) && innerItem.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  v-acl="['diagnoses_image']"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  v-else
                                  @click.stop
                                >&#xe630e;</div>
                                <div class="iconfont" v-acl="['gen_online_report']" @click.stop="showOnlineReport(ele.id)">  
                                  <img src="../assets/online_report.png" style="width: 17px;height:15px;margin-left:15px;margin-top:2px" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="innerItem.typeDignoses=='美容'"
                            class="check-box2"
                            @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                          >
                            <div class="imgBack cardImg">
                              <template v-if="innerItem.image_cosmetology.length > 0">
                                <template
                                  v-for="(imgItem, imgIndex) in innerItem.image_cosmetology"
                                >
                                  <img
                                    :src="imageSrcPrefixThumbnails2 + imgItem.path"
                                    :key="imgIndex"
                                    v-if="imgIndex === 0"
                                    alt
                                    class="checkBoxImg"
                                    :class="{'heightAuto': imgItem.width<imgItem.height,'widthAuto': imgItem.width>=imgItem.height}"
                                  />
                                </template>
                              </template>
                            </div>
                            <div class="check-info">
                              <p
                                style="display: flex;justify-content: space-between"
                                :title="innerItem.title"
                              >
                                <span class="cosmetology">
                                  项目:
                                  <span>{{innerItem.title}}</span>
                                </span>
                              </p>
                              <p class="cosmetology">
                                创建时间:
                                <span>{{innerItem.time}}</span>
                              </p>
                              <p class="ellipsisP cosmetology">
                                次数:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >第{{innerItem.leftNum}}次/共{{innerItem.total}}次</span>
                              </p>
                              <div
                                style="display: flex;align-items: flex-end;justify-content: space-between"
                              >
                                <p class="ellipsisP cosmetology">
                                  备注:
                                  <span class="ellipsis ellipsisSpan">{{innerItem.remarks}}</span>
                                </p>
                                <div
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold"
                                  title="编辑美容"
                                  v-acl="['export_cosmetology']"
                                  @click.stop="modifyCosmetology(innerItem)"
                                  v-if="innerItem.isedit === 1"
                                >&#xe630e;</div>
                                <div
                                  class="iconfont"
                                  style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                  title="不可编辑"
                                  v-acl="['export_cosmetology']"
                                  @click.stop=""
                                  v-else
                                >&#xe630e;</div>
                              </div>
                            </div>
                          </div>
                          <div
                            @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                            class="check-box2 inHospitalCard"
                            v-if="innerItem.typeDignoses=='住院'"
                          >
                            <div class="imgBack cardImg">
                              <template v-if="innerItem.image_hospitalization.length > 0">
                                <img
                                  :src="hospitalization_imagesThumbnails
                            +innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].path"
                                  alt
                                  class="checkBoxImg"
                                  :class="{'heightAuto':innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].width<innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].height,'widthAuto':innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].width>=innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].height}"
                                />
                              </template>
                            </div>
                            <div class="check-info">

                              <p>
                                记录时间:
                                <span>{{innerItem.update_time}}</span>
                              </p>
                              <p>
                                病程及诊断:  
                                <span>{{innerItem.disease_course}};</span>                            
                                <span>{{innerItem.diagnosis | formatConclusion}}</span>                              
                              </p>     
                              <p class="ellipsisP">
                                病情:
                                <span class="ellipsis ellipsisSpan">{{innerItem.curative_effect}}</span>
                              </p>       


                              <!-- <p>
                                入院时间:
                                <span>{{innerItem.inpat_date}}</span>
                              </p>
                              <p>
                                出院时间:
                                <span>{{innerItem.outpat_date}}</span>
                              </p>
                              <p class="ellipsisP">
                                诊断:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >{{innerItem.diagnosis | formatConclusion}}</span>
                              </p> -->
                              <template>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    备注:
                                    <span
                                      class="ellipsis ellipsisSpan"
                                    >{{innerItem.remarks}}</span>
                                  </p>
                                  <div
                                    class="iconfont"
                                    v-acl="['inhospital_order']"
                                    style="font-size: 16px;margin-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑住院信息"
                                    @click.stop="getInHospital(innerItem.id,item)"
                                    v-if="innerItem.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['inhospital_order']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div>
                                </div>
                              </template>
                            </div>
                          </div>
                          <div
                            @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                            v-if="innerItem.typeDignoses=='手术'"
                            class="check-box2 operation"
                          >
                            <div
                              class="imgBack cardImg"
                              :style="`background-image: url(${operationDoctor})`"
                              style="background-size: contain;background-position: center center;background-repeat:  no-repeat;background-color: rgb(246,246,246)"
                            ></div>
                            <div class="check-info">
                              <p>
                                手术时间:
                                <span>{{innerItem.operation_date | formatTime1}}</span>
                              </p>
                              <p>
                                手术名称:
                                <span>{{innerItem.operation_name}}</span>
                              </p>
                              <p class="ellipsisP">
                                手术部位:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >&nbsp{{innerItem.operation_position}}</span>
                              </p>
                              <template v-if="innerItem.doctor_conclusion">
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    手术医生:
                                    <span
                                      class="ellipsis ellipsisSpan"
                                    >&nbsp{{innerItem.operation_doctor}}</span>
                                  </p>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑手术信息"
                                    @click.stop="getOperationl(innerItem,item)"
                                    v-if="innerItem.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="编辑手术信息"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div>
                                </div>
                              </template>
                              <template v-else>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p>
                                    诊断结果:
                                    <span
                                      :title="innerItem.relevant_info[0].diagnosis | formatConclusion"
                                    >{{innerItem.relevant_info[0].diagnosis | formatConclusion}}</span>
                                  </p>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑手术信息"
                                    @click.stop="getOperationl(innerItem,item)"
                                    v-if="innerItem.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="编辑手术信息"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div>
                                </div>
                              </template>
                            </div>
                          </div>
                          <div
                            @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                            class="check-box2 inHospitalCard"
                            v-if="innerItem.typeDignoses=='白癜风基础'"
                          >
                            <div class="imgBack cardImg">
                              <!-- <template v-if="ele.image_hospitalization.length > 0">
                                <img
                                  :src="hospitalization_imagesThumbnails
                              +ele.image_hospitalization[ele.image_hospitalization.length - 1].path"
                                  alt
                                  class="checkBoxImg"
                                  :class="{'heightAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width<ele.image_hospitalization[ele.image_hospitalization.length - 1].height,'widthAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width>=ele.image_hospitalization[ele.image_hospitalization.length - 1].height}"
                                />
                              </template> -->
                            </div>
                            <div class="check-info">
                              <p>
                                记录时间:
                                <span>{{innerItem.visit_date}}</span>
                              </p>
                              <p>
                                类型及病程:  
                                <span>{{innerItem.vitiligo_type}};</span>                            
                                <span>{{innerItem.duration_months}}</span>                              
                              </p>     
                              <p class="ellipsisP">
                                现部位:
                                <span class="ellipsis ellipsisSpan">{{innerItem.current_location}}</span>
                              </p>                      
                              <p class="ellipsisP">
                                BAS评分:
                                <span>{{innerItem.bsa_score}}</span>
                              </p>
                              <p class="ellipsisP">
                                用药:
                                <span>{{innerItem.topical_medication}}</span>
                              </p>

                              <template>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    备注:
                                    <span class="ellipsis ellipsisSpan">{{innerItem.remark1}}|{{innerItem.remark2}}|{{innerItem.remark3}}</span>
                                  </p>
                                  <div
                                    class="iconfont"
                                    v-acl="['sd_vitiligo']"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑信息"
                                    @click.stop="getVitiligo(innerItem.id,item)"
                                    v-if="innerItem.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['sd_vitiligo']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div>
                                </div>
                              </template>
                            </div>
                          </div>
                          <div
                            @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                            class="check-box2 inHospitalCard"
                            v-if="innerItem.typeDignoses=='黑色素瘤'"
                          >
                            <div class="imgBack cardImg">
                            </div>
                            <div class="check-info">
                              <p>
                                记录时间:
                                <span>{{innerItem.visit_date}}</span>
                                <span v-if="innerItem.baseline===1" class="baseline-badge">基线</span>
                              </p>
                              <p class="ellipsisP">
                                原发部位:
                                <span class="ellipsis ellipsisSpan">{{innerItem.primary_site}}</span>
                              </p>
                              <p class="ellipsisP">
                                AJCC8分期:
                                <span>{{innerItem.ajcc8_clinical_stage}}</span>
                              </p>
                              <p class="ellipsisP">
                                手术方式:
                                <span class="ellipsis ellipsisSpan">{{innerItem.method_of_first_surgery}}</span>
                              </p>
                              <template>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: flex-end"
                                >
                                  <!-- v-if="innerItem.isedit === 1" 点击进入对话框，但是会根据isedit状态判断是否可编辑 -->
                                  <div
                                    class="iconfont"
                                    v-acl="['sd_mm']"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑信息"
                                    @click.stop="getMm(innerItem.id, innerItem.isedit===1, item)"
                                    
                                  >&#xe630e;</div>
                                  <!-- <div
                                    class="iconfont"
                                    v-acl="['sd_mm']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div> -->
                                </div>
                              </template>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="waiting" class="noData">
                    <img src="../assets/loading.png" class="loadingWait" />
                  </div>
                  <div v-if="!waiting">
                    <template v-if="resultArr.length === 0">暂无诊断数据</template>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="this.currentPage"
                :page-size="this.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="this.pageTotal">
              </el-pagination>
            </ul>
            </div>
            <InHospitalDialog
              :openHospitalId="openHospitalId"
              :isShowInHospital="isShowInHospital"
              :toDialoPatientsData="toDialoPatientsData"
              :lastDiagnosisText="lastDiagnosisText"
              @setInHpspitalStatus="setInHpspitalStatus()"
              @refreshHandler="refreshHandler"
            ></InHospitalDialog>
            <vitiligoBasicInfoDialog
              :openVitiligoId="openVitiligoId"
              :isShowVitiligo="isShowVitiligo"
              :toDialoPatientsData="toDialoPatientsData"
              :lastDiagnosisText="lastDiagnosisText"
              @setVitiligoStatus="setVitiligoStatus()"
              @refreshHandler="refreshHandler"
            ></vitiligoBasicInfoDialog>
            <MmBasicInfoDialog
              :openMmId="openMmId"
              :isShowMm="isShowMm"
              :toDialoPatientsData="toDialoMmPatientsData"
              @setMmStatus="setMmStatus($event)"
              @refreshHandler="refreshHandler"
              @refreshHandler1="refreshHandler1"
            ></MmBasicInfoDialog>

            <div class="resetPatients">
              <el-dialog
                title="患者信息编辑"
                class="dialog patient-edit-dialog"
                :visible.sync="reviseInfo"
                width="1050px"
                :close-on-click-modal="false"
                @close="reviseInfoClose"
              >
                <div class="navBorder"></div>
                <div id="addpaintent">
                  <el-form :model="form2" :rules="rules" ref="form22" inline>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.name}">
                        <p class="rightItemTitle popTitleDialog">姓名<span style="color:red;">**</span></p>
                        <el-form-item prop="name" ref="form2Name">
                          <el-input
                            v-model="form2.name"
                            maxlength="64"
                            type="text"
                            class="popInput"
                            @input="form2.name = form2.name.replace(/\d/g, '')"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.patientNumber}">
                        <p class="rightItemTitle popTitleDialog">ID<span style="color:red;">**</span></p>
                        <el-form-item prop="id_in_hospital" ref="id_in_hospital">
                          <el-autocomplete
                            v-model="form2.patientNumber"
                            :fetch-suggestions="querySearchPatientNumber"
                            :trigger-on-focus="false"
                            @select="selectPatientNumber"
                            type="text"
                            class="popInput"
                            :disabled="form2IdDisabled"
                            @input="form2.patientNumber = form2.patientNumber.replace(/[\u4e00-\u9fa5]/g, '')"
                          ></el-autocomplete>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="leftItem">
                        <p class="rightItemTitle popTitleDialog">性别<span style="color:red;">**</span></p>
                        <el-radio-group v-model="form2.gender" class="popInput isBW" size="medium">
                          <el-radio-button class="isBWItem" label="男"></el-radio-button>
                          <el-radio-button class="isBWItem" label="女"></el-radio-button>
                        </el-radio-group>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.birthday}">
                        <p class="rightItemTitle popTitleDialog">出生日期<span style="color:red;">*</span></p>
                        <el-form-item>
                          <el-date-picker
                            v-model="form2.birthday"
                            prefix-icon="iconfont icon-rili"
                            class="popInput"
                            align="right"
                            type="date"
                            default-value="1980-01-01"
                            :clearable="false"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.age}">
                        <p class="rightItemTitle popTitleDialog">年龄<span style="color:red;">*</span></p>
                        <el-form-item prop>
                          <el-input
                            class="popInput"
                            type="text"
                            v-model="form2.age"
                            placeholder
                            @input="form2.age =
                              form2.age.replace(/[^\d]/g, '')"
                            maxlength="3"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.phone}">
                        <p class="rightItemTitle popTitleDialog">手机号码</p>
                        <el-form-item prop ref="form2Phone">
                          <el-input
                            v-model="form2.phone"
                            type="text"
                            class="popInput"
                            maxlength="11"
                            @input="form2.phone = form2.phone.replace(/[^\d]/g, '')"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.phone2}">
                        <p class="rightItemTitle popTitleDialog">手机号码2</p>
                        <el-form-item prop>
                          <el-input
                            v-model="form2.phone2"
                            type="text"
                            class="popInput"
                            maxlength="11"
                            @input="form2.phone2 = form2.phone2.replace(/[^\d]/g, '')"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.height}">
                        <p class="rightItemTitle popTitleDialog">身高(cm)</p>
                        <el-form-item prop>
                          <el-input
                            v-model="form2.height"
                            type="number"
                            class="popInput"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.weight}">
                        <p class="rightItemTitle popTitleDialog">体重(kg)</p>
                        <el-form-item prop>
                          <el-input
                            v-model="form2.weight"
                            type="number"
                            class="popInput"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.skin_type}">
                        <p class="rightItemTitle popTitleDialog">皮肤类型</p>
                        <el-form-item id="raceType-select" prop>
                          <el-select
                            v-model="form2.skin_type"
                            placeholder
                            size
                            class="popInput"
                            :disabled="readonly"
                          >
                            <el-option
                              v-for="item in skinOpsType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.skin_color}">
                        <p class="rightItemTitle popTitleDialog">肤色</p>
                        <el-form-item id="race-select" prop>
                          <el-select
                            v-model="form2.skin_color"
                            placeholder
                            size
                            class="popInput"
                            :disabled="readonly"
                          >
                            <el-option
                              v-for="item in skinOps"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.id_card_number}">
                        <p class="rightItemTitle popTitleDialog">身份证</p>
                        <el-form-item prop ref="form2Id_card_number">
                          <el-input
                            v-model="form2.id_card_number"
                            class="popInput"
                            type="text"
                            maxlength="18"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div :class="{'leftItem': true, 'field-filled': form2.address}">
                        <p class="rightItemTitle popTitleDialog">地址</p>
                        <el-form-item prop>
                          <el-input
                            :readonly="readonly"
                            v-model="form2.address"
                            type="text"
                            class="popInput popInputSingle2"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.profession}">
                        <p class="rightItemTitle popTitleDialog">职业</p>
                        <el-form-item prop>
                          <el-select
                            v-model="form2.profession"
                            placeholder
                            size
                            class="popInput"
                            filterable
                            allow-create
                            default-first-option
                          >
                            <el-option
                              v-for="item in professionOpts"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.education}">
                        <p class="rightItemTitle popTitleDialog">文化程度</p>
                        <el-form-item prop>
                          <el-select
                            v-model="form2.education"
                            placeholder
                            size
                            class="popInput"
                          >
                            <el-option
                              v-for="item in educationOpts"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.smoking}">
                        <p class="rightItemTitle popTitleDialog">是否吸烟</p>
                        <el-form-item prop>
                          <el-select
                            v-model="form2.smoking"
                            placeholder
                            size
                            class="popInput"
                          >
                            <el-option
                              v-for="item in smokingOpts"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.drinking}">
                        <p class="rightItemTitle popTitleDialog">是否饮酒</p>
                        <el-form-item prop>
                          <el-select
                            v-model="form2.drinking"
                            placeholder
                            size
                            class="popInput"
                          >
                            <el-option
                              v-for="item in drinkingOpts"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.dietHabitArr && form2.dietHabitArr.length}">
                        <p class="rightItemTitle popTitleDialog">饮食习惯</p>
                        <el-form-item prop>
                          <el-select
                            v-model="form2.dietHabitArr"
                            placeholder
                            size
                            class="popInput"
                            multiple
                            @change="handleDietHabitChange"
                          >
                            <el-option
                              v-for="item in dietHabitOpts"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.native_place}">
                        <p class="rightItemTitle popTitleDialog">籍贯</p>
                        <el-form-item prop>
                          <el-input v-model="form2.native_place" type="text" class="popInput"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.race}">
                        <p class="rightItemTitle popTitleDialog">民族</p>
                        <el-form-item prop ref="form2Race">
                          <el-input v-model="form2.race" type="text" class="popInput"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.email}">
                        <p class="rightItemTitle popTitleDialog">电子邮箱</p>
                        <el-form-item prop>
                          <el-input v-model="form2.email" type="text" class="popInput"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div :class="{'leftItem': true, 'field-filled': form2.country}">
                        <p class="rightItemTitle popTitleDialog">国别</p>
                        <el-form-item prop>
                          <el-input v-model="form2.country" type="text" class="popInput"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div :class="{'leftItem': true, 'field-filled': form2.note}">
                        <p class="rightItemTitle popTitleDialog">备注</p>
                        <el-form-item prop>
                          <el-input
                            v-model="form2.note"
                            type="textarea"
                            :rows="2"
                            class="popInput popInputSingle2"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8" :offset="16">
                      <button
                        class="btn iconfont leftItemSubmit2"
                        @click.prevent="addPatient"
                        style="padding: 0"
                        v-if="isAddPatient"
                      >添加</button>
                      <button
                        class="btn iconfont leftItemSubmit2"
                        @click.prevent="revisePatient"
                        style="padding: 0"
                        v-else
                      >保存</button>
                    </el-col>
                  </el-form>
                </div>
              </el-dialog>
            </div>

            <div v-if="showInfo" class="detailed-info"></div>
          </template>
          <div class="mask" v-if="resiltsVisible" @click="closeResult"></div>
          <transition name="fade">
            <div v-if="resiltsVisible" class="resilts">
              <el-button
                @click="closeResult"
                style="position: absolute;right: 5.6rem;top: 2.5rem;z-index:999;"
                type="primary"
                icon="el-icon-close"
                circle
              ></el-button>
              <DetailedResults
                :wordbook="wordbook"
                :detail_result="detail_result"
                :imgList="imgList3"
                v-on:compare="compare"
              />
            </div>
          </transition>
          <el-dialog
            title="相似图片对比"
            :visible.sync="compareDialog"
            width="90%"
            center
            top="36px"
            custom-class="similarDialog"
            modal
          >
            <div class="imgWrapper">
              <div class="chooseImgCon">
                <div class="cs-text">选择图片</div>
                <div class="imgBack">
                  <img
                    :src="compareImgObj.choosedImg"
                    v-bind:style="{'width': compareImgObj.choosedWidth + 'px','height': compareImgObj.choosedHeight + 'px'}"
                  />
                </div>
              </div>
              <div class="chooseImgCon">
                <div class="cs-text">相似图片</div>
                <div class="imgBack">
                  <img
                    :src="compareImgObj.compareImg"
                    v-bind:style="{'width': compareImgObj.compareWidth + 'px','height': compareImgObj.compareHeight + 'px'}"
                  />
                </div>
              </div>
            </div>
          </el-dialog>
        
          <!-- 云胶片详细信息 对话框-->
          <div class="mask" v-if="showOnlineReportDetail" @click="closeOnlineReport"></div>
          <el-dialog
            title="云胶片详情"
            class="dialog"
            :visible.sync="showOnlineReportDetail"
            width="800px"
            center
            top="50px"
            :close-on-click-modal="true"
            @close="closeOnlineReport"
          >
            <div class="navBorder"></div>
            <div>
              <el-form  inline> 
                <el-col :span="10">
                  <div class="leftItem">
                    <p class="rightItemTitle popTitleDialog">云胶片状态：{{onlineReport.online_report_state}}</p>
                  </div>
                </el-col>
                <el-col :span="14">
                  <div class="leftItem">
                    <p class="rightItemTitle popTitleDialog">医生创建时间：{{onlineReport.created_time?onlineReport.created_time:"尚未创建"}}</p>
                  </div>
                </el-col>         
                <el-col :span="10">
                  <div class="leftItem">
                    <p class="rightItemTitle popTitleDialog">患者查阅时间：{{onlineReport.download_time?onlineReport.download_time:"尚未查阅"}}</p>
                  </div>
                </el-col>
                <el-col :span="14">
                  <!-- 只有在 已生成/未查阅  状态时，才显示重发短信-->
                  <div class="leftItem" v-if="onlineReport.online_report_state==='已生成/未查阅'">
                    <p class="rightItemTitle popTitleDialog">通知短信状态：{{"已发送 "+onlineReport.note+" 次 "}}
                    <el-button
                            @click.stop="resendSMSNotification"
                            size="mini"
                            type="primary"
                            class="btn"
                            style="width: 70px;display:inline-block; "
                          >重发短信
                    </el-button></p>

                    <!-- <p class="rightItemTitle popTitleDialog"  style="color:blue" @click.stop="resendSMSNotification">重发短信</p> -->
                  </div>
                </el-col>   
              </el-form>
            </div>
            <div style="width:90%; display:flex;flex-direction:column; justify-content:center; align-items:center;margin-top:20px">
              <div v-if="onlineReport.imgNum===0">
                <p class="rightItemTitle popTitleDialog">未获取到云胶片！</p>
              </div>
              <div v-if="onlineReport.imgNum===1">
                <div style="display:flex;flex-direction:row; justify-content:center; align-items:center;">
                  <img
                    :src="onlineReport.base64[0]"
                    style="width:500px"
                  />
                </div>
              </div>
              <div v-if="onlineReport.imgNum===2">
                <div style="display:flex;flex-direction:row; justify-content:space-between; align-items:center;">
                  <img
                    :src="onlineReport.base64[0]"
                    style="width:400px"
                  />
                  <img
                    :src="onlineReport.base64[1]"
                    style="width:400px"
                  />
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
     
      <!--  <div class="pagination">
          <el-button type="primary" :disabled="prevDisabled" @click="prevPage">上一页</el-button>
          <div class="current-page">{{currentPage}}</div>
          <el-button type="primary" :disabled="nextDisabled" @click="nextPage">下一页</el-button>
        </div>-->
      </el-main>
    </el-container>
  </div>
</template>
<script>
import axios from "axios";
import api from "../api";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import csrftoken from "../getToken";
import moment from "../../node_modules/moment/src/moment.js";
// import PatientsGQL from "../gql/getPatients.gql";
import PatientsGQLByPage from "../gql/getPatientsByPage.gql";
// 获取某患者的详细 action 信息
import getPatientsPatientList from "../gql/getPatientsPatientList.gql";
// 获取某患者的详细 action 数量信息
import getPatientActionNum    from "../gql/getPatientActionNum.gql";
import raceJson from "../race.js";
import gql from "graphql-tag";
import PatientDiagnoseRecord from "./PatientDiagnoseRecord.vue";
import DetailedResults from "./DetailedResults.vue";
import FilterGQL from "../gql/filter.gql";
import PatientsPaging from "../gql/patientsPaging.gql";
import InHospital from "../utils/inHospital.js";
import vitiligoBasicInfo from "../utils/vitiligoBasicInfo.js";
import mmBasicInfo from "../utils/mmBasicInfo.js";
import patientsSearch from "../utils/patientsSearch.js";
import operationDoctor from "../assets/operationDoctor.jpg";
import popMixins from "../utils/popMixins.js";
import controllerDuration from "../utils/controllerDuration.js";

// 医生自定义模板
let template = {};
let that;
export default {
  name: "PatientList",
  data() {
    const checkIdInHospital = async (rule, value, callback) => {
      if (this.form2.patientNumber === "") {
        callback("请输入ID");
      } else {
        const bool = await this.patientIdRepeat(this.form2.patientNumber);
        if (bool) {
          callback("ID已存在");
        }
      }
    };
    const checkIdCardNumber = async (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value === "") {
        callback();
        this.form2Verify.id_card_number = true;
      } else {
        if (reg.test(value)) {
          callback();
          this.form2Verify.id_card_number = true;
        } else {
          callback("");
          this.form2Verify.id_card_number = false;
        }
      }
    };
    // 校验电话号码
    const checkPhone = (rule, value, callback) => {
      let reg = /^1\d{10}/;
      if (reg.test(value)) {
        callback();
        this.form2Verify.phone = true;
      } else {
        callback("");
        this.form2Verify.phone = false;
      }
    };
    return {
      operationDoctor,
      hospitalization_imagesThumbnails: api.hospitalization_imagesThumbnails,
      imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
      imageSrcPrefixThumbnails2: api.cosmetology_imagesThumbnails,
      // 分页相关参数
      prevDisabled: true,
      nextDisabled: true,
      currentPage: 1,

      inlineForm: true,
      readonly: false,
      // 显示单独的诊断记录
      singleDiagnose: false,
      skinOps: raceJson.skinOpn,
      skinOpsType:raceJson.skinOpnType,
      educationOpts: raceJson.educationOptions,
      professionOpts: raceJson.professionOptions,
      smokingOpts: raceJson.smokingOptions,
      drinkingOpts: raceJson.drinkingOptions,
      dietHabitOpts: raceJson.dietHabitOptions,
      // 是否显示比较图片的弹框
      compareDialog: false,
      // 显示全部诊断信息
      showall: false,
      // 年龄数据
      ageValues: raceJson.age,
      // 选择的年龄
      checkedAge: 0,
      // 民族数据
      nationValues: raceJson.raceObj,
      // checked nation
      checkedNation: "",
      // resiltsVisible 是否显示智能搜图结果
      resiltsVisible: false,
      compareImgObj: {},
      patients: [],
      // patients2: [],
      resultArr: [],
      diagnoses: [],
      // 单个patient 的 各类activion的数量，按顺序包括影像、手术、住院、美容等,后续可以扩展
      //currentDiagnosesNum:{"dignoses":0, "operation":0, "inHospital":0, "cosmetology":0 },
      detail_result: [],
      imgList3: [],
      currentIndex: null,
      isHid: false,
      wordbook: null,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      options: [
        {
          value: "",
          label: "请选择性别"
        },
        {
          value: "男",
          label: "男"
        },
        {
          value: "女",
          label: "女"
        }
      ],
      keywordString: "",
      input2: null,
      sex: "",
      value1: null,
      startAge: "",
      endAge: "",
      sDate: "",
      diagnosis_type:'',
      diagnosisTypeList:[
        {key:1,val:'影像诊断'},{key:2,val:'美容/治疗'},{key:3,val:'手术'},{key:4,val:'住院'}
      ],
      knowledgeDic: {},
      form: {
        name: "",
        gender: "男",
        phone: "",
        race: "",
        birthday: "",
        patientNumber: "",
        address: "",
        skin_color: "",
        skin_type:""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        birthday: [{ required: true, trigger: "blur" }],
        id_in_hospital: {
          required: true,
          validator: checkIdInHospital,
          trigger: "blur"
        }
        // id_card_number: {
        //   required: false,
        //   validator: checkIdCardNumber,
        //   trigger: "blur"
        // }
      },
      form2: {
        // 患者的id
        id: "",
        patientNumber: "",
        name: "",
        gender: "男",
        address: "",
        phone: "",
        race: "",
        birthday: "",
        age: "",
        skin_color: "",
        id_card_number: "",
        native_place: "",
        country: "",
        profession: "",
        email: "",
        skin_type: "",
        phone2: "",
        education: "",
        smoking: "",
        drinking: "",
        dietHabitArr: [],
        diet_habit: "",
        height: "",
        weight: "",
        note: "",
      },
      form2Verify: {
        id: true,
        phone: true,
        id_card_number: true
      },
      rules2: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 64, message: "长度在 2 到 64 个字符", trigger: "blur" }
        ],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        birthday: [{ required: true, trigger: "blur" }],
        patientNumber: [
          { required: true, message: "请输入门诊号", trigger: "blur" }
        ]
      },
      patientId: "",
      patientId2: "",
      showInfo: false,
      diagnosisId: "",
      reviseInfo: false,
      allNum: 0,
      isdel: false,
      deletePatientId: null,
      activeName: "0",
      moreResultArr: [],
      // 传递给子组件的患者信息
      patientInfo: {},
      // 传递给子组件的诊断信息
      diagnoseInfo: [],
      waiting: true,
      // 下载数据时提示
      getPatientListLoading: false,
      // 百科全书
      wordbook: {},
      // 分页显示条数
      currentPage:1,
      pageTotal:0,
      pageSize: 14,
      initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
      hasClumsOpen: false, // 是否有列表被展开
      orderStatus: "desc", // false为倒叙，true为正序
      orderFiled: "update_time", // 排序名称
      form2IdDisabled: true,
      isAddPatient: false,
      // 限制显示编辑按钮的时间值 毫秒
      // countTimeModifyDiagnosisBtn: 604800000,
      
      // 随访患者选择，全选状态
      isIndeterminate: false,
      checkAll: false,
      // 勾选的拟加入随访的患者数量
      checkedNum:0,
      // 加入随访按钮的使能
      followup_disabled: true,
      // 显示云胶片状态对话框
      showOnlineReportDetail: false,
      // 云胶片具体信息
      onlineReport:{}, 
      // 短信多大发送次数
      maxSmsSentTimes: 3,
    };
  },
  mixins: [InHospital, vitiligoBasicInfo, mmBasicInfo, patientsSearch, popMixins, controllerDuration],
  async mounted() {
    that = this;
    // 请求医生自定义模板
    await this.queryMyTemplate();
    let res1 = await axios.request({
      method: "get",
      url: api.wordbook,
      headers: {
        "x-csrf-token": csrftoken
      },
      withCredentials: true
    });
    this.wordbook = res1.data;
    // this.orderStatus = "desc";
    // 请求患者基本数据
    // console.log("In patientlist, mounted, and begin searchName.");
    this.searchName();
    axios
      .request({
        method: "get",
        url: api.wordbook,
        headers: {
          "x-csrf-token": csrftoken
        },
        withCredentials: true
      })
      .then(res => {
        this.wordbook = res.data;
      })
      .catch(error => {
        // console.log(error);
      });
    const knowledgeDic = await axios.request({
      method: "get",
      url: api.knowledgeDic
    });
    this.knowledgeDic = knowledgeDic.data;
  },


  // activated() {
  //   console.log("In patientList, activated.");
  // },
  // created() {
  //   console.log('In patientList, created')
  // },

  methods: {
    async handleCurrentChange(val) {
      this.currentPage = val;
      await this.searchName();
      //await this.getPatientsDiagnoses();
    },
    async querySearchPatientNumber(queryString, callback) {
      if (queryString !== "") {
        const res = await this.$apollo.query({
          query: gql`query($keyword: String){
                      patients(keyword: $keyword) {
                        id
                        id_in_hospital
                      }
                  }`,
          fetchPolicy: "no-cache",
          variables: {
            keyword: queryString,
          },
        });
        const arr = res.data.patients;
        const newArr = [];
        for (let i of arr) {
          newArr.push({
            value: `${i.id_in_hospital}`,
            id: i.id
          });
        }
        callback(newArr);
      }
    },
    selectPatientNumber() {
      this.$refs.form22.validateField('id_in_hospital');
    },

    getOperationl(data, patientinfo) {
      // console.log(data,item)
      this.$store.commit("setoperationClearClick", true);
      this.$store.commit("seteditOperation", true);
      this.$store.commit("setoperationPatientId", patientinfo.id);
      this.$store.commit("setoperationElectiveId", data.id);
      this.$store.commit("setoperationRelevantId", data.relevant_info[0].id);
      this.$router.push({ name: "operation" });
    },
    // 检查患者id是否重复
    async patientIdRepeat(value) {
      const res = await this.$apollo.query({
        query: gql`
          query($id_in_hospital: String!) {
            getByIdInHospital(id_in_hospital: $id_in_hospital) {
              id
            }
          }
        `,
        variables: {
          id_in_hospital: value
        },
        fetchPolicy: "no-cache"
      });
      const arr = res.data.getByIdInHospital;
      
      return arr.length > 0;
    },
    // 饮食习惯多选互斥逻辑
    handleDietHabitChange(val) {
      if (val.includes('正常') && val.length > 1) {
        const lastItem = val[val.length - 1];
        if (lastItem === '正常') {
          this.form2.dietHabitArr = ['正常'];
        } else {
          this.form2.dietHabitArr = val.filter(v => v !== '正常');
        }
      }
    },
    // 将数组转为逗号分隔字符串
    dietHabitArrToString() {
      return this.form2.dietHabitArr.join(',');
    },
    // 将逗号分隔字符串转为数组
    dietHabitStringToArr(str) {
      if (!str) return [];
      return str.split(',').filter(s => s);
    },
    reviseInfoClose() {
      // 初始化状态
      this.$refs.id_in_hospital.resetField();
      this.$refs.form2Name.resetField();
      this.form2IdDisabled = true;
      this.form2 = {
        // 患者的id
        id: "",
        patientNumber: "",
        name: "",
        gender: "男",
        address: "",
        phone: "",
        race: "",
        birthday: "",
        age: "",
        skin_color: "",
        skin_type: "",
        id_card_number: "",
        native_place: "",
        country: "",
        profession: "",
        email: "",
        phone2: "",
        education: "",
        smoking: "",
        drinking: "",
        dietHabitArr: [],
        diet_habit: "",
        height: "",
        weight: "",
        note: "",
      };
      this.isAddPatient = false;
    },
    async order(data) {
      if (this.orderStatus === "asc") {
        this.orderStatus = "desc";
      } else {
        this.orderStatus = "asc";
      }
      // "asc",'desc'
      this.orderFiled = data;
      // console.log(data)
      await this.searchName();
      //await this.getPatientDiagnoses();
    },
    // 添加新的患者
    newPatient() {
      this.reviseInfo = true;
      this.form2IdDisabled = false;
      this.isAddPatient = true;
    },
    // 添加患者
    async addPatient() {
      const newval = this.form2;
      if (!newval.patientNumber) {
        this.$message.error("请输入ID");
        return;
      }
      if (!newval.name) {
        this.$message.error("请输入姓名");
        return;
      }
      if (!newval.birthday && !this.form2.age) {
        this.$message.error("出生年月和年龄至少填一项");
        return;
      }
      const bool = await this.patientIdRepeat(this.form2.patientNumber);
      if (!bool) {
        // 同步 dietHabitArr 到 diet_habit 字符串
        this.form2.diet_habit = this.dietHabitArrToString();
        let addRes = await this.addSicker(newval);
        // 刷新患者列表
        if (addRes) {
          await this.refreshPatientList();
          this.$message({
            type: "success",
            message: "添加患者成功"
          });
          this.reviseInfo = false;
        }
      }
    },
    // 请求添加病人
    async addSicker(params) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id_in_hospital: String!
              $name: String!
              $gender: String!
              $birthday: String!
              $age: Int
              $race: String!
              $skin_color: String!
              $skin_type: String!
              $phone: String!
              $address: String!
              $id_card_number: String!
              $native_place: String!
              $country: String!
              $profession: String!
              $email: String!
              $phone2: String
              $education: String
              $smoking: String
              $drinking: String
              $diet_habit: String
              $height: Float
              $weight: Float
              $note: String
            ) {
              addPatient(
                id_in_hospital: $id_in_hospital
                name: $name
                gender: $gender
                birthday: $birthday
                race: $race
                skin_color: $skin_color
                skin_type: $skin_type
                phone: $phone
                address: $address
                id_card_number: $id_card_number
                native_place: $native_place
                country: $country
                profession: $profession
                email: $email
                age: $age
                phone2: $phone2
                education: $education
                smoking: $smoking
                drinking: $drinking
                diet_habit: $diet_habit
                height: $height
                weight: $weight
                note: $note
              ) {
                id
              }
            }
          `,
          variables: {
            id_in_hospital: params.patientNumber,
            name: params.name,
            gender: params.gender,
            birthday: params.birthday
              ? params.birthday
              : moment(this.initialTime).format("YYYY-MM-DD"),
            age: params.age ? Number(params.age) : -1,
            race: params.race,
            skin_color: params.skin_color,
            skin_type: params.skin_type,
            phone: params.phone,
            address: params.address,
            id_card_number: params.id_card_number,
            native_place: params.native_place,
            country: params.country,
            profession: params.profession,
            email: params.email,
            phone2: params.phone2 || null,
            education: params.education || null,
            smoking: params.smoking || null,
            drinking: params.drinking || null,
            diet_habit: params.diet_habit || null,
            height: params.height ? Number(params.height) : null,
            weight: params.weight ? Number(params.weight) : null,
            note: params.note || null
          }
        });
        return true;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
        return false;
      }
    },
    // 添加患者到随访列表
    async newFollowup(){ 
      let hintMessage = "将添加" + this.checkedNum + "名患者进入随访队列";
      this.$confirm(hintMessage, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            console.log("In newFollowup");
            let newFollowupPatients = [];
            console.log(this.patients);
            for (let item of this.patients) {
                if (item.checked){
                  // console.log(item.doctor_id); // It's a regret, undefined!!
                  newFollowupPatients.push({  
                    // doctor_id: item.doctor_id,        
                    patient_id: item.id, 
                    name: item.name,
                    gender: item.gender, 
                    id_in_hospital: item.id_in_hospital           
                  });
                }
            }
            newFollowupPatients = JSON.stringify(newFollowupPatients);
            this.$store.commit("setHasAddedNewFollowupPatient", false);
            console.log("newFollowup,setHasAddedNewFollowupPatient:",this.$store.state.hasAddedNewFollowupPatient);
            // 新开随访页签并跳转到随访页签
            let routeUrl = this.$router.resolve({
              path: "followup",
              query: {'newFollowupPatients':newFollowupPatients}
            });
            window.open(routeUrl.href, '_blank');
            // console.log("newFollowup: navigate to new tab page.newFollowupPatients",newFollowupPatients);
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        })
        .catch(() => {
          // console.log('取消删除');
        });
    },
    // 获取医生自定义模板
    async queryMyTemplate() {
      // 请求医生自定义的模板路径
      const res = await this.$apollo.query({
        query: gql`
          {
            me {
              id
              template
            }
          }
        `,
        fetchPolicy: "no-cache"
      });
      // 根据路径请求模板
      const path = res.data.me.template;
      // 如果没有自定义模板
      if (path === "") {
        return;
      }
      const msg = await axios.request({
        method: "get",
        url: api.template + path
      });
      template = msg.data;
    },
    background(type) {
      if (type === "住院") {
        return "#fff3cd";
      } else if (type === "手术") {
        return "#EBFDE8";
      } else if (type === "美容") {
        return "rgb(254,216,216)";
      }else if (type === "白癜风基础") {
        return "rgb(220,246,246)";
      }else if (type === "黑色素瘤") {
        return "rgb(230,230,250)";
      }
    },
    typeBadge(type) {
      const map = {
        '影像': '影',
        '美容': '美',
        '住院': '院',
        '手术': '术',
        '白癜风基础': 'V',
        '黑色素瘤': 'M'
      };
      return map[type] || '';
    },
    typeBadgeColor(type) {
      const map = {
        '影像': '#999999',
        '美容': '#c86a6a',
        '住院': '#c8aa3c',
        '手术': '#50a046',
        '白癜风基础': '#3ca0a0',
        '黑色素瘤': '#6464b4'
      };
      return map[type] || '#999999';
    },
    // 算年龄
    getAge(birthday, age, createdTime) {
      let showAge;
      if (birthday !== this.initialTime) {
        showAge = moment().diff(birthday, "years");
      } else if (age > -1) {
        showAge = age + moment().diff(createdTime, "years");
      }
      return showAge;
    },
    // 患者列表上显示的打印状态
    handlePrintStatus(diagnoses) {
      let status = '无';
      if (diagnoses.length > 0) {
        let num = 0;
        for (const item of diagnoses) {
          if (item.images) {
            const index = item.images.findIndex(
              item => item.print_time !== this.initialTime
            );
            // diagnosesItem.isPrintReport = !(index > -1);
            if (index > -1) {
              num++;
            }
          }
        }
        if (num === diagnoses.length) {
          status = '完成打印';
        } else {
          status = '未打印';
        }
      }
      return status;
    },
    
    // check whether online_report_state error/regular/note, set different style. 2024-0507
    handleOnlineReportStatus(online_report_state) {
      let status = '';
      // error
      if ( online_report_state.indexOf('手机号缺失') != -1  || online_report_state.indexOf('失败') != -1) {
        status = -1;
        // regular
      } else if(online_report_state.indexOf('已查阅') != -1) {
        status = 0;
        // note
      }else if(online_report_state.indexOf('未查阅') != -1) {
        status = 1;
      }
      return status;
    },
    // 全选或取消
    handleCheckAllChange(val) {
      this.checkAll = val;
      console.log("In handleCheckAllChange, val:", this.checkAll)
      this.isIndeterminate = false;
      if (val){
        for (const item of this.patients) {
          item.checked = true;
        }
        this.checkedNum = this.patients.length;
        this.followup_disabled = false
      } else {
        for (const item of this.patients) {
          item.checked = false;
        }     
        this.checkedNum = 0;
        this.followup_disabled = true
      }
    },

    handleCheckChange(val) {      
      var num = 0; 
      for (const item of this.patients) {
          if (item.checked){
            num += 1;
          }
      }
      this.checkedNum = num;
      if (num === this.patients.length){
        this.checkAll = true;
        this.isIndeterminate = false;
        this.followup_disabled = false;
      } else if (num===0){
        this.checkAll = false;
        this.isIndeterminate = false;    
        this.followup_disabled = true    
      } else {
        this.checkAll = false;
        this.isIndeterminate = true;
        this.followup_disabled = false;
      }

    },

    async compare(data) {
      let self = this;
      data.choosedImg = data.choosedImg.replace("thumbnails/", "");
      await this.adaptImage(data.choosedImg, "choosedWidth", "choosedHeight");
      await this.adaptImage(data.compareImg, "compareWidth", "compareHeight");
      this.compareImgObj.choosedImg = data.choosedImg;
      this.compareImgObj.compareImg = data.compareImg;
      this.compareDialog = true;
    },
    adaptImage(url, typeWidth, typeHeight) {
      let self = this;
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = url;
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if (width / height < 654 / 500) {
            img.height = 500;
            img.width = (width * 500) / height;
          } else {
            img.width = 654;
            img.height = (height * 654) / width;
          }
          self.compareImgObj[typeWidth] = img.width;
          self.compareImgObj[typeHeight] = img.height;
          resolve();
        };
      });
    },
    closeResult() {
      this.resiltsVisible = false;
    },
    // 显示所有的诊断记录信息
    showAll() {
      this.showall = true;
      // 分割数据
    },
    showHid(index, id) {
      this.showall = false;
    },
    getMessageFromChildren(data) {
      switch (data.type) {
        case "showIntell":
          this.detail_result = data.detail_result;
          this.imgList3 = data.imgList;
          this.resiltsVisible = true;
          break;
      }
    },
    async revisePatient() {
      // const isSuccessful = this.form2Verify.id_card_number === true && this.form2.name !== '' &&
      //   this.form2.birthday !== '' && this.form2.id !== '' && this.form2.gender !== '';
      // if (!isSuccessful) {
      //   this.$message.error('格式不正确');
      //   return;
      // }
      if (!this.form2.name) {
        this.$message.error("请输入姓名");
        return;
      }
      if (!this.form2.birthday && !this.form2.age) {
        this.$message.error("出生年月和年龄至少填一项");
        return;
      }
      const params = {
        id: this.form2.id,
        id_in_hospital: this.form2.patientNumber,
        name: this.form2.name,
        birthday: this.form2.birthday
          ? this.form2.birthday
          : moment(this.initialTime).format("YYYY-MM-DD"),
        gender: this.form2.gender,
        race: this.form2.race,
        skin_color: this.form2.skin_color,
        skin_type: this.form2.skin_type,
        phone: this.form2.phone,
        address: this.form2.address,
        id_card_number: this.form2.id_card_number,
        country: this.form2.country,
        native_place: this.form2.native_place,
        profession: this.form2.profession,
        email: this.form2.email,
        age: this.form2.age ? Number(this.form2.age) : -1,
        phone2: this.form2.phone2 || null,
        education: this.form2.education || null,
        smoking: this.form2.smoking || null,
        drinking: this.form2.drinking || null,
        diet_habit: this.dietHabitArrToString() || null,
        height: this.form2.height ? Number(this.form2.height) : null,
        weight: this.form2.weight ? Number(this.form2.weight) : null,
        note: this.form2.note || null
      };
      try {
        let self = this;
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id: Int!
              $id_in_hospital: String
              $name: String
              $gender: String
              $birthday: String
              $race: String
              $skin_color: String
              $skin_type: String
              $phone: String
              $address: String
              $id_card_number: String
              $native_place: String
              $country: String
              $profession: String
              $email: String
              $age: Int
              $phone2: String
              $education: String
              $smoking: String
              $drinking: String
              $diet_habit: String
              $height: Float
              $weight: Float
              $note: String
            ) {
              modifyPatient(
                id: $id
                age: $age
                id_in_hospital: $id_in_hospital
                name: $name
                gender: $gender
                birthday: $birthday
                race: $race
                skin_color: $skin_color,
                skin_type: $skin_type,
                phone: $phone
                address: $address
                id_card_number: $id_card_number
                native_place: $native_place
                country: $country
                profession: $profession
                email: $email
                phone2: $phone2
                education: $education
                smoking: $smoking
                drinking: $drinking
                diet_habit: $diet_habit
                height: $height
                weight: $weight
                note: $note
              )
            }
          `,
          variables: params,
          fetchPolicy: "no-cache"
        });
        this.reviseInfo = false;
        this.form2.name = "";
        this.form2.age = "";
        this.form2.gender = "男性";
        this.form2.phone = "";
        this.form2.race = "";
        this.form2.birthday = "";
        this.form2.patientNumber = "";
        this.form2.id = "";
        this.form2.address = "";
        this.form2.skin_color = "";
        this.form2.skin_type = "";
        this.form2.id_card_number = "";
        this.form2.country = "";
        this.form2.native_place = "";
        this.form2.profession = "";
        this.form2.email = "";
        this.form2.phone2 = "";
        this.form2.education = "";
        this.form2.smoking = "";
        this.form2.drinking = "";
        this.form2.dietHabitArr = [];
        this.form2.diet_habit = "";
        this.form2.height = "";
        this.form2.weight = "";
        this.form2.note = "";
        // 刷新患者列表
        await this.refreshPatientList();
        this.$message({
          type: "success",
          message: "修改成功"
        });
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    // 刷新患者列表
    async refreshPatientList() {
      this.patients = [];
      let refreshPatientListRes = await this.$apollo.query({
        query: PatientsGQLByPage,
        variables: {
          page_number: this.currentPage,
          page_size: this.pageSize
        },
        fetchPolicy: "no-cache"
      });
      for (const value of refreshPatientListRes.data.patients) {
        // console.log("In refreshPatientList, value:",value);
        
        // 获取患者各类action的数量
        let diagnosesNum = {};
        diagnosesNum = await this.getPatientDiagnoses(value.id);

        const showAge = this.getAge(
          value.birthday,
          value.age,
          value.created_time
        );

        this.patients.push({
          name: value.name,
          gender: value.gender,
          id: value.id,
          doctor_id: value.doctor.id,
          id_in_hospital: value.id_in_hospital,
          phone: value.phone,
          created_time: moment(value.created_time).format("YYYY-MM-DD HH:mm"),
          update_time: moment(value.update_time).format("YYYY-MM-DD HH:mm"),
          birthday: moment(value.birthday).format("YYYY-MM-DD"),
          age: value.age,
          last_diagnosis: value.last_diagnosis,
          address: value.address,
          race: value.race,
          skin_color: value.skin_color,
          skin_type: value.skin_type,
          id_card_number: value.id_card_number,
          native_place: value.native_place,
          country: value.country,
          profession: value.profession,
          email: value.email,
          showAge,
          // 是否勾选
          checked: false,
          printStatus: this.handlePrintStatus(value.diagnoses),
          // check whether online_report_state has error, 2023-11-15
          onlineReportStatus:this.handleOnlineReportStatus(value.last_diagnosis?value.last_diagnosis.online_report_state:''),
          // last_diagnosis 可能为null
          online_report_state: value.last_diagnosis?value.last_diagnosis.online_report_state:'',
          // added by zdh
          diagnosesNum: diagnosesNum,
        });
      }
    },
    // 新建影像检查
    async newDiagnose(event, item) {
      event.cancelBubble = true;
      let params = {};
      params.id = item.id;
      params.birthday = item.birthday;
      params.created_time = item.created_time;
      // params.update_time = item.update_time;
      params.age = item.age;
      params.address = item.address !== "undefined" ? item.address : "";
      params.id_card_number =
        item.id_card_number !== "undefined" ? item.id_card_number : "";
      params.id_in_hospital = item.id_in_hospital;
      params.country = item.country !== "undefined" ? item.country : "";
      params.email = item.email !== "undefined" ? item.email : "";
      params.gender = item.gender;
      params.name = item.name;
      params.native_place =
        item.native_place !== "undefined" ? item.native_place : "";
      params.phone = item.phone;
      params.profession =
        item.profession !== "undefined" ? item.profession : "";
      params.race = item.race;
      params.skin_color = item.skin_color;
      params.skin_type = item.skin_type;

      // Old way. 2025-02-07
      // this.$store.commit("setPToIntell", params);
      // this.$router.push({ name: "Intell" });
      
      // New way. 2025-02-07, modified by Steven. Create new tab for new page. 通过query将指针和参数传递给新页面
      params.from = "newDiagnosis";
      let routeUrl = this.$router.resolve({
        path: "intell",
        query: params
      });
      window.open(routeUrl.href, '_blank');
    },

    // 新建手术记录
    async newOperation(event, item) {
      event.cancelBubble = true;
      let params = {};
      params.id = item.id;
      params.birthday = item.birthday;
      params.created_time = item.created_time;
      params.age = item.age;
      params.address = item.address !== "undefined" ? item.address : "";
      params.id_card_number =
        item.id_card_number !== "undefined" ? item.id_card_number : "";
      params.id_in_hospital = item.id_in_hospital;
      params.country = item.country !== "undefined" ? item.country : "";
      params.email = item.email !== "undefined" ? item.email : "";
      params.gender = item.gender;
      params.name = item.name;
      params.native_place =
        item.native_place !== "undefined" ? item.native_place : "";
      params.phone = item.phone;
      params.profession =
        item.profession !== "undefined" ? item.profession : "";
      params.race = item.race;
      params.skin_color = item.skin_color;
      params.skin_type = item.skin_type;
      this.$store.commit("setPToIntell", params);
      this.$router.push({ name: "operation" });
    },
    // 新建美容/治疗
    newCosmetology(event, item) {
      // this.$store.commit('addCosmetology', {
      //   patient_id: item.id,
      // });
      
      // Old way.
      // this.$router.push({name: 'hairdressing'})

      // New way. 2024-12-09, modified by Steven. Create new tab for new page. 通过query将指针和参数传递给新页面
      let routeUrl = this.$router.resolve({
        path: "hairdressing",
        query: {
          patient_id: item.id,
          from: "newCosmetology"
        }
      });
      window.open(routeUrl.href, '_blank');
      // console.log("In PatientList->newCosmetology, after creat new tab, I am OLD page, patient_id:",item.id);
    },
    async showRevise(event, id) {
      // 重置form表单验证状态
      if (this.$refs.form2Name) {
        this.$refs.form2Name.resetField();
      }
      if (this.$refs.form2Race) {
        this.$refs.form2Race.resetField();
      }
      if (this.$refs.form2Phone) {
        this.$refs.form2Phone.resetField();
      }
      if (this.$refs.form2Id_card_number) {
        this.$refs.form2Id_card_number.resetField();
      }
      event.cancelBubble = true;
      this.activeName = "";
      this.reviseInfo = true;
      this.patientId2 = id;
      let self = this;
      let res = await this.$apollo.query({
        query: gql`
          query($id: Int!) {
            patient(id: $id) {
              id
              name
              gender
              skin_color
              skin_type
              phone
              address
              birthday
              age
              race
              id_in_hospital
              id_card_number
              native_place
              country
              profession
              email
              phone2
              education
              smoking
              drinking
              diet_habit
              height
              weight
              note
            }
          }
        `,
        variables: {
          id: self.patientId2
        },
        fetchPolicy: "no-cache"
      });
      let resData = res.data.patient;
      this.form2.id = resData.id;
      this.form2.skin_color = resData.skin_color;
      this.form2.name = resData.name;
      this.form2.skin_type = resData.skin_type;
      this.form2.gender = resData.gender;
      this.form2.patientNumber = resData.id_in_hospital;
      this.form2.phone = resData.phone;
      this.form2.race = resData.race;
      this.form2.birthday =
        resData.birthday === this.initialTime
          ? ""
          : moment(resData.birthday).format("YYYY-MM-DD");
      this.form2.age = resData.age > -1 ? resData.age + "" : "";
      this.form2.address = resData.address;
      this.form2.id_card_number = resData.id_card_number;
      this.form2.native_place = resData.native_place;
      this.form2.country = resData.country;
      this.form2.profession = resData.profession;
      this.form2.email = resData.email;
      this.form2.phone2 = resData.phone2 || "";
      this.form2.education = resData.education || "";
      this.form2.smoking = resData.smoking || "";
      this.form2.drinking = resData.drinking || "";
      this.form2.dietHabitArr = this.dietHabitStringToArr(resData.diet_habit);
      this.form2.diet_habit = resData.diet_habit || "";
      this.form2.height = resData.height || "";
      this.form2.weight = resData.weight || "";
      this.form2.note = resData.note || "";
    },

    // // 获取全部患者各类action数量
    // async getPatientsDiagnoses(){
    //   for (const patient of this.patients) {
    //     let patientId = patient.id;
    //     let patientsData = await this.$apollo.query({
    //       query: getPatientsPatientList,
    //       variables: {
    //         id: Number(patientId)
    //       },
    //       fetchPolicy: "no-cache"
    //     });
    //     const filterPatient = patientsData.data.patient; 
    //     let diagnosesNum = {};
    //     diagnosesNum = {
    //       diagnoses: filterPatient.diagnoses.length,
    //       operation: filterPatient.operation.length,
    //       inHospital: filterPatient.hospitalization.length,
    //       cosmetology: filterPatient.cosmetology.length
    //     };
    //     patient.diagnosesNum = diagnosesNum;
    //     //console.log("In getPatientDiagnoses, patientId:", patientId, " diagnosesNum:",diagnosesNum);
    //     //return diagnosesNum
    //   }
    // },
 
    // 获取指定患者各类action数量
    async getPatientDiagnoses(patientId){
      // 旧方法，耗时较多
      let patientsData = await this.$apollo.query({
        query: getPatientsPatientList,
        variables: {
          id: Number(patientId)
        },
        fetchPolicy: "no-cache"
      });
      const filterPatient = patientsData.data.patient; 
      let diagnosesNum = {};
      diagnosesNum = {
        diagnoses: filterPatient.diagnoses.length,
        operation: filterPatient.operation.length,
        inHospital: filterPatient.hospitalization.length,
        cosmetology: filterPatient.cosmetology.length,
        vitiligoBasicInfo: filterPatient.vitiligoBasicInfo.length,
        mmBasicInfo: filterPatient.mmBasicInfo.length
      };

      // 新方法，2024-1217. 需要与后台v3.7.2匹配
      // let patientsData = await this.$apollo.query({
      //   query: getPatientActionNum,
      //   variables: {
      //     id: Number(patientId)
      //   },
      //   fetchPolicy: "no-cache"
      // });
      // const filterPatient = patientsData.data.patient; 
      // let diagnosesNum = {};
      // diagnosesNum = {
      //   diagnoses: filterPatient.diagnoses_num,
      //   operation: filterPatient.operation_num,
      //   inHospital: filterPatient.hospitalization_num,
      //   cosmetology: filterPatient.cosmetology_num
      // };
      // console.log("In getPatientDiagnoses, patientId:", patientId, " diagnosesNum:",diagnosesNum);
      return diagnosesNum
    },

    // 获取患者信息，带搜索条件或者不带搜索条件，有排序或者无排序
    async searchName() {
      try {    
        let res;
        let ageReg = /[0-9]+/;
        let start_age;
        let end_age;
        let gender;
        let startTime;
        let endTime;
        let race;
        let keywordStr;
        let diagnosis_type;
        start_age = null;
        start_age = end_age = gender = startTime = endTime = race = keywordStr = null;

        if (this.startAge !== "" && ageReg.test(this.startAge)) {
          start_age = Number(this.startAge);
        }
        if (this.endAge !== "" && ageReg.test(this.endAge)) {
          end_age = Number(this.endAge);
        }
        if (this.checkedNation !== "") {
          race = this.checkedNation;
        }
        if (this.keywordString !== "") {
          keywordStr = this.keywordString;
        }
        if (this.sex !== "") {
          gender = this.sex;
        }
        if (this.sDate !== "" && this.sDate !== null) {
          startTime = moment(this.sDate[0]).format("YYYY-MM-DD HH:mm:ss");
          endTime = moment(this.sDate[1]).format("YYYY-MM-DD HH:mm:ss");
        }
        if (this.diagnosis_type !== "") {
          diagnosis_type = this.diagnosis_type;
        }
        this.getPatientListLoading = true;
        // console.time("searchName-runtime");
        res = await this.$apollo.query({
          query: PatientsPaging,
          variables: {
            keyword: keywordStr,
            gender,
            age_start: start_age,
            age_end: end_age,
            race,
            time_start: startTime,
            time_end: endTime,
            page_number: this.currentPage,
            page_size: this.pageSize,
            order_filed: this.orderFiled,
            order_type: this.orderStatus,
            diagnosis_type
          },
          fetchPolicy: "no-cache"
        });
        // console.timeEnd("searchName-runtime");
        this.getPatientListLoading = false;

        this.patients = [];
        this.pageTotal = res.data.patientsPaging.count
        for (const value of res.data.patientsPaging.data) {
          //获取患者各类action的数量
          let diagnosesNum = {};
          diagnosesNum = await this.getPatientDiagnoses(value.id);
          
          // console.log("In searchName, diagnosesNum:",diagnosesNum);
          //console.log("diagnosesNum.operationNum:",diagnosesNum.operationNum);
          // this.patients.push({
          //   "diagnosesNum": diagnosesNum,
          // });

          // 算年龄
          const showAge = this.getAge(
            value.birthday,
            value.age,
            value.created_time
          );
          this.patients.push({
            name: value.name,
            gender: value.gender,
            id: value.id,
            id_in_hospital: value.id_in_hospital,
            phone: value.phone,
            created_time: moment(value.created_time).format("YYYY-MM-DD HH:mm"),
            update_time: moment(value.update_time).format("YYYY-MM-DD HH:mm"),
            birthday: moment(value.birthday).format("YYYY-MM-DD"),
            age: value.age,
            // diagnoses: value.diagnoses,
            address: value.address,
            race: value.race,
            skin_color: value.skin_color,
            skin_type: value.skin_type,
            id_card_number: value.id_card_number,
            native_place: value.native_place,
            country: value.country,
            profession: value.profession,
            last_diagnosis_text:this.formatConclusion(value.last_diagnosis_text),
            email: value.email,
            showAge,
            // 是否勾选
            checked: false,
            printStatus: this.handlePrintStatus(value.diagnoses),          
            // check whether online_report_state has error, 2023-11-15
            onlineReportStatus:this.handleOnlineReportStatus(value.last_diagnosis?value.last_diagnosis.online_report_state:''),
            // last_diagnosis 可能为null
            online_report_state: value.last_diagnosis?value.last_diagnosis.online_report_state:'',          
            // added by zdh
            diagnosesNum: diagnosesNum,
          });

        }
        // console.log("After get patients in searchName(), length:",this.patients.length);
        
        return res.data.patients;
      }catch(error) {
        console.log("Searchname error:",error)
        this.getPatientListLoading = false;        
      }
    },

    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (this.knowledgeDic[id]) {
          name = this.knowledgeDic[id].name;
        }
      }
      return name ? name : id;
    },
    // 点击某患者诊断卡片后，跳转到按日期滚动排序的详细就诊记录
    getInfo(id, id2, type) {
      this.showInfo = true;
      this.singleDiagnose = true;
      this.patientId = id2;
      this.diagnosisId = id;
      const params = {
        patientId: id2,
        selectId: id,
        diagnosisType: type
      };
      // console.log("In patientlist, getInfo."); 
      
      //采用全局变量缓存参数
      this.$store.commit("setPatientDiagnosisRecordPara", {
          patientId: params.patientId,
          selectId: params.selectId,
          diagnosisType: params.diagnosisType
      });
      this.$router.push({ name: "details" });

      // // 不跳转新标签页,采用sessionStorage缓存参数
      // if (window.sessionStorage) {
      //   this.$router.push({ name: "details" });
      //   window.sessionStorage.setItem(
      //     "diagnosisParams",
      //     JSON.stringify(params)
      //   );
      // } else {
      //   this.$router.push({
      //     name: "details",
      //     params
      //   });
      // }

      // 跳转新标签页,采用sessionStorage缓存参数
      // if (window.sessionStorage) {
      //   window.sessionStorage.setItem(
      //     "diagnosisParams",
      //     JSON.stringify(params)
      //   );
      //   let routeUrl = this.$router.resolve({
      //     path: "details",
      //     //query: {id:96}
      //   });
      //   window.open(routeUrl.href, '_blank');
      //   console.log("In getInfo, sessionStorage is true; after creat new tab, I am OLD page");
      // } else {
      //   let routeUrl = this.$router.resolve({
      //     path: "details",
      //     query: params
      //   });
      //   window.open(routeUrl.href, '_blank');
      //   console.log("In getInfo, sessionStorage is false; after creat new tab, I am OLD page");
      // }

      // setTimeout(() => {
      //   this.refreshPatientList();
      //   //this.searchName();
      //   console.log("In getInfo, after refreshPatientList.");
		  // }, 3000);


    },
    

    // 展开一个患者的详细action/item，包括diagnosis/inhospital/operation/cosmetology
    async changeHandler(patientId) {
      // console.log("In changeHandler, patientId:",patientId, "this.activeName:",this.activeName);
      this.waiting = true;
      this.showall = false;
      // this.hasClumsOpen = !this.hasClumsOpen
      if (patientId) {
        let patientsData = await this.$apollo.query({
          query: getPatientsPatientList,
          variables: {
            id: Number(patientId)
          },
          fetchPolicy: "no-cache"
        });
        const filterPatient = patientsData.data.patient;
        for (const diagnosesItem of filterPatient.diagnoses) {
          const index = diagnosesItem.images.findIndex(
            item => item.print_time !== this.initialTime
          );
          diagnosesItem.isPrintReport = !(index > -1);
        }
        this.resultArr = [];
        if (this.activeName !== "") {
          if (patientId === this.activeName) {
            this.diagnoses = filterPatient.diagnoses;
            let inHospitalData = filterPatient.hospitalization;
            let operationData = filterPatient.operation;
            let hairdressingData = filterPatient.cosmetology;
            let vitiligoBasicInfo = filterPatient.vitiligoBasicInfo;
            let mmBasicInfoData = filterPatient.mmBasicInfo;
            // 处理影像数据
            for (let n = 0; n < this.diagnoses.length; n++) {
              this.diagnoses[n].time1 = this.diagnoses[n].time;
              this.diagnoses[n].time = moment(this.diagnoses[n].time).format(
                "YYYY-MM-DD HH:mm"
              );
              this.diagnoses[n].typeDignoses = "影像";
              if (this.diagnoses[n].images.length > 0) {
                // 将图片的宽高获取到
                let imgZeroObj = this.diagnoses[n].images[0];
                let newImgZeroObj = await this.getImgWidth(
                  api.imageSrcPrefixThumbnails + imgZeroObj.path
                );
                imgZeroObj.width = newImgZeroObj.width;
                imgZeroObj.height = newImgZeroObj.height;
              }
            }
            // 处理住院数据
            for (let n = 0; n < inHospitalData.length; n++) {
              let inHospitalArray = {};
              inHospitalArray = inHospitalData[n];
              inHospitalArray.remarks =  inHospitalData[n].remarks;
              inHospitalArray.disease_course  =  inHospitalData[n].disease_course;
              inHospitalArray.time1 = inHospitalData[n].update_time;
              inHospitalArray.update_time = inHospitalData[n].update_time?moment(inHospitalData[n].update_time).format("YYYY-MM-DD") : "";
              inHospitalArray.time = moment(
                inHospitalData[n].created_time
              ).format("YYYY-MM-DD HH:mm");
              inHospitalArray.inpat_date =
                inHospitalData[n].inpat_date !== this.initialTime
                  ? moment(inHospitalData[n].inpat_date).format("YYYY-MM-DD")
                  : "";
              inHospitalArray.outpat_date =
                inHospitalData[n].outpat_date !== this.initialTime
                  ? moment(inHospitalData[n].outpat_date).format("YYYY-MM-DD")
                  : "";
              inHospitalArray.typeDignoses = "住院";
              await this.diagnoses.push(inHospitalArray);
              if (inHospitalArray.image_hospitalization.length > 0) {
                // 将图片的宽高获取到
                let imgZeroObj2 =
                  inHospitalArray.image_hospitalization[
                    inHospitalArray.image_hospitalization.length - 1
                  ];
                let newImgZeroObj = await this.getImgWidth(
                  api.hospitalization_imagesThumbnails + imgZeroObj2.path
                );
                imgZeroObj2.width = newImgZeroObj.width;
                imgZeroObj2.height = newImgZeroObj.height;
              }
            }
            // 处理手术数据
            for (let n = 0; n < operationData.length; n++) {
              let operationArray = {};
              operationArray = operationData[n];
              operationArray.time1 = operationData[n].update_time;
              operationArray.typeDignoses = "手术";
              await this.diagnoses.push(operationArray);
            }
            
            // 处理美容数据
            // console.log("hairdressingData:", hairdressingData);
            for (let n = 0; n < hairdressingData.length; n++) {
              let hairdressingArray = {};
              hairdressingArray = hairdressingData[n];
              hairdressingArray.time1 = hairdressingData[n].create_time;
              hairdressingArray.typeDignoses = "美容";
              hairdressingArray.title = "";
              hairdressingArray.total = hairdressingArray.total_times;
              hairdressingArray.leftNum = hairdressingArray.current_times;
              // console.log(hairdressingArray)
              hairdressingArray.time = moment(
                hairdressingData[n].create_time
              ).format("YYYY-MM-DD HH:mm");
              for (
                let m = 0;
                m < hairdressingData[n].treat_details.length;
                m++
              ) {
                if (m === hairdressingData[n].treat_details.length - 1) {
                  // 2024-12-09, modified by Steven. 之前呈现的项目名称，修改后呈现的模块/药物
                  // if (hairdressingData[n].treat_details[m].item_info) {
                  //   hairdressingArray.title +=
                  //     hairdressingData[n].treat_details[m].item_info.item_name;
                  // }
                  if (hairdressingData[n].treat_details[m].module_info) {
                    hairdressingArray.title +=
                      hairdressingData[n].treat_details[m].module_info.module_name;
                  }

                } else {
                  // 2024-12-09, modified by Steven. 之前呈现的项目名称，修改后呈现的模块/药物
                  // if (hairdressingData[n].treat_details[m].item_info) {
                  //   hairdressingArray.title +=
                  //     hairdressingData[n].treat_details[m].item_info.item_name +
                  //     ",";
                  // }
                  if (hairdressingData[n].treat_details[m].module_info) {
                    hairdressingArray.title +=
                      hairdressingData[n].treat_details[m].module_info.module_name +
                      ",";
                  }
                }
                // if (m === 0) {
                //   hairdressingArray.total =
                //     hairdressingData[n].treat_details[m].total_times;
                //   hairdressingArray.leftNum =
                //     hairdressingData[n].treat_details[m].total_times -
                //     hairdressingData[n].treat_details[m].left_times;
                // }
              }
              if (hairdressingData[n].image_cosmetology.length > 0) {
                // 将图片的宽高获取到
                let imgZeroObj = hairdressingData[n].image_cosmetology[0];
                let newImgZeroObj = await this.getImgWidth(
                  api.cosmetology_imagesThumbnails + imgZeroObj.path
                );
                imgZeroObj.width = newImgZeroObj.width;
                imgZeroObj.height = newImgZeroObj.height;
              }
              await this.diagnoses.push(hairdressingArray);
            }
            // 处理白癜风基础数据
            for (let n = 0; n < vitiligoBasicInfo.length; n++) {
              let vitiligoBasicInfoArray = {};
              vitiligoBasicInfoArray = this.transformVitiligoData(vitiligoBasicInfo[n]); // 数字和日期格式化
              vitiligoBasicInfoArray.time1 = vitiligoBasicInfo[n].visit_date;
              vitiligoBasicInfoArray.update_time = vitiligoBasicInfo[n].update_time?moment(vitiligoBasicInfo[n].update_time).format("YYYY-MM-DD") : "";
              vitiligoBasicInfoArray.time = moment( vitiligoBasicInfo[n].created_time ).format("YYYY-MM-DD HH:mm");
              vitiligoBasicInfoArray.visit_date = vitiligoBasicInfo[n].visit_date ? moment(vitiligoBasicInfo[n].visit_date).format("YYYY-MM-DD") : "";
              
              vitiligoBasicInfoArray.typeDignoses = "白癜风基础";
              await this.diagnoses.push(vitiligoBasicInfoArray);              
            }
            // 处理黑色素瘤基础数据
            for (let n = 0; n < mmBasicInfoData.length; n++) {
              let mmBasicInfoArray = {};
              mmBasicInfoArray = this.transformMmData(mmBasicInfoData[n]); // 数字和日期格式化
              mmBasicInfoArray.time1 = mmBasicInfoData[n].visit_date;
              mmBasicInfoArray.update_time = mmBasicInfoData[n].update_time?moment(mmBasicInfoData[n].update_time).format("YYYY-MM-DD") : "";
              mmBasicInfoArray.time = moment( mmBasicInfoData[n].create_time ).format("YYYY-MM-DD HH:mm");
              mmBasicInfoArray.visit_date = mmBasicInfoData[n].visit_date ? moment(mmBasicInfoData[n].visit_date).format("YYYY-MM-DD") : "";
              
              mmBasicInfoArray.typeDignoses = "黑色素瘤";
              await this.diagnoses.push(mmBasicInfoArray);              
            }

          }
          this.waiting = false;
          let sumList1 = _.cloneDeep(this.diagnoses);
          let sumList = _.sortBy(sumList1, item => {
            return -item.time1;
          });
          if (sumList.length > 0) {
            this.resultArr = _.chunk(sumList, 4);
            let newarr = _.cloneDeep(this.resultArr);
            this.moreResultArr = _.drop(newarr);
          } else {
            this.resultArr = [];
            // this.$message.error("暂无诊断数据");
          }
        } else {
          this.resultArr = [];
          this.moreResultArr = [];
          this.showall = false;
        }
      }
      // 处理数据查看是否有打印过报告
      // if (patientId) {
      //   const filterPatient = this.patients.filter(item => item.id === patientId);
      //   for (const diagnosesItem of filterPatient[0].diagnoses) {
      //     const index = diagnosesItem.images.findIndex(item => item.print_time !== this.initialTime)
      //     diagnosesItem.isPrintReport = !(index > -1)
      //   }
      // }
    },
    getImgWidth(path) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        let aa = {};
        img.src = path;
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if (width / height < 155 / 115) {
            img.height = 115;
            img.width = (width * 115) / height;
          } else {
            img.width = 155;
            img.height = (height * 155) / width;
          }
          // imgZeroObj.width = img.width;
          // imgZeroObj.height = img.height;
          resolve({ width: img.width, height: img.height });
        };
      });
    },
    showDelete(id) {
      this.deletePatientId = id;
      this.isdel = true;
    },
    closeInfo() {
      this.showInfo = false;
    },
    // 编辑诊断
    async modifyDiagnosis(diagnosisId) {
      // 请求相关数据
      try {
        
        // patientinfo.birthday = moment(patientinfo.birthday).format(
        //   "YYYY-MM-DD"
        // );

        // Open new page in current tab. 2023-0928, by zdh
        // this.$store.commit("addModifyDiagnosis", {
        //   diagnosisId
        // });        
        // this.$router.push("/home/intell");

        // Open new page in new tab. 通过query将指针和参数传递给新页面
        let routeUrl = this.$router.resolve({
          path: "intell",
          query: {
            diagnosisId:diagnosisId,
            from: "modifyDiagnosis"
          }
        });
        window.open(routeUrl.href, '_blank');
        // console.log("In modifyDiagnosis, after creat new tab, I am OLD page, diagnosisId:",diagnosisId);

        // Open new page in new tab. 通过sessionStorage将指针和参数传递给新页面。this.$store.commit("addModifyDiagnosis")不能跨页面传输信息。
        // sessionStorage.diagnosisParams 会在 Intelligent.vue中，用完后销毁。
        // if (window.sessionStorage) {
        //   window.sessionStorage.setItem(
        //     "diagnosisParams",
        //     JSON.stringify({'diagnosisId':diagnosisId})
        //   );
        //   let routeUrl = this.$router.resolve({
        //     path: "intell",
        //     query: {diagnosisId:diagnosisId}
        //   });
        //   window.open(routeUrl.href, '_blank');
        // } else {
        //   let routeUrl = this.$router.resolve({
        //     path: "intell",
        //     query: {'diagnosisId':diagnosisId}
        //   });
        //   window.open(routeUrl.href, '_blank');          
        // }            
        // console.log("In modifyDiagnosis,modifyDiagnosisData.isModify and diagnosisId:",this.$store.state.modifyDiagnosisData.isModify, this.$store.state.modifyDiagnosisData.diagnosisId);
        // console.log("In modifyDiagnosis,window.sessionStorage:",window.sessionStorage);   
      
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    
    // 获取onlineReport 详细信息，并打开对话框大图显示
    // id 为''时表示未生成云胶片或者生成失败；online_report_state 始终不为空；download_time为null时表示患者尚未查阅；names为图片名称数组，base64为图片数据数组
    async showOnlineReport(id){
      try {
        this.onlineReport = {};
        const res = await this.$apollo.mutate({
          mutation: gql`mutation($diagnosis_id: Int!){
                      getOnlineReport(diagnosis_id: $diagnosis_id) {
                        id
                        create_time
                        download_time
                        online_report_state
                        names
                        base64
                        note 
                      }
                  }`,
          fetchPolicy: "no-cache",
          variables: {
            diagnosis_id: id,
          },
        });
        // console.log("getOnlineReport,data:",res.data.getOnlineReport);
        if(res.data.getOnlineReport.create_time){
          this.onlineReport['created_time'] = moment(res.data.getOnlineReport.create_time).format("YYYY-MM-DD HH:mm");
        }else{
          this.onlineReport['created_time'] = '';
        }
        if(res.data.getOnlineReport.download_time){
          this.onlineReport['download_time'] = moment(res.data.getOnlineReport.download_time).format("YYYY-MM-DD HH:mm");
        }else{
          this.onlineReport['download_time'] = '';
        }    
        this.onlineReport['id'] = res.data.getOnlineReport.id;
        this.onlineReport['note'] = res.data.getOnlineReport.note; // string; sent sms tines;
        this.onlineReport['online_report_state'] = res.data.getOnlineReport.online_report_state;
        this.onlineReport['names'] = res.data.getOnlineReport.names;
        this.onlineReport['base64'] = [];
        this.onlineReport['imgNum'] = res.data.getOnlineReport.base64.length;

        for(let img of res.data.getOnlineReport.base64){
          this.onlineReport['base64'].push('data:image/png;base64,' + img );
        }
        // console.log("getOnlineReport,onlineReport:",this.onlineReport);
        this.showOnlineReportDetail = true;
      }catch (error) {
        console.log("in showOnlineReport，error:",error);
        this.$message.error(error.message.split(":")[1]);
      }

    },

    // 关闭 onlineReport 对话框大图显示
    async closeOnlineReport(){
      this.showOnlineReportDetail = false;
    },
    
    // 重新发送短信通知（为当前打开详情的云胶片）
    async resendSMSNotification(){
      try {
        let online_report_id = this.onlineReport['id'];  //  该值来自 showOnlineReport()
        if(online_report_id){
          if(!this.onlineReport['note'] ||  this.onlineReport['note'] < this.maxSmsSentTimes){         
            const res = await this.$apollo.mutate({
              mutation: gql`mutation($online_report_id: Int!){
                          resendSMSNotification(online_report_id: $online_report_id) 
                      }`,
              fetchPolicy: "no-cache",
              variables: {
                online_report_id: online_report_id,
              },
            });
            // console.log("Get resendSMSNotification result:",res.data.resendSMSNotification);
            // 返回值为""，代表异常
            if(!res.data.resendSMSNotification){
              this.$message({
                type: "error",
                message: "重发短信失败！"
              });
              // 重发成功，返回值为字符串,如"1" "2"
            }else{
              this.onlineReport['note'] = res.data.resendSMSNotification;
              this.$message({
                type: "success",
                message: "重发短信成功！"
              });
            }

          }else{
            this.$message({
              type: "error",
              message: "已达短信发送最大次数！"
            });
          }
        }

      }catch (error) {
        // console.log("in resendSMSNotification:",error);
        this.$message.error(error.message.split(":")[1]);
      }
    },

    // 是否显示编辑按钮
    isShowModifyDiagnosisBtn(date) {
      return !(moment().diff(date) >= this.countTimeModifyDiagnosisBtn);
    },
    // 编辑美容
    async modifyCosmetology(item) {
      // Old way.
      // this.$store.commit('addModifyCosmetology', {
      //   patient_id: item.patient_id,
      //   treat_no: item.treat_no,
      //   current_times: item.current_times,
      //   total_times: item.total_times,
      //   parent_id: item.parent_id ? item.parent_id : item.treat_no,
      // });
      // this.$router.push({name: 'hairdressing'});
      
      // New way. 2024-12-12, modified by Steven. Create new tab for new page. 通过query将指针和参数传递给新页面
      let routeUrl = this.$router.resolve({
        path: "hairdressing",
        query: {
          patient_id: item.patient_id,
          treat_no: item.treat_no,
          current_times: item.current_times,
          total_times: item.total_times,
          parent_id: item.parent_id ? item.parent_id : item.treat_no,
          from: "modifyCosmetology"
        }});
      window.open(routeUrl.href, '_blank');
      // console.log("In PatientList->newCosmetology, after creat new tab, I am OLD page, patient_id:",item.id);
    }
  },
  components: {
    swiper,
    swiperSlide,
    PatientDiagnoseRecord,
    DetailedResults
  },
  filters: {
    formatTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    formatTime1(time) {
      return moment(time).format("YYYY-MM-DD");
    },
    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (that.wordbook[id]) {
          name = that.wordbook[id].name;
        }
      }
      return name ? name : id;
    }
  }
};
</script>
<style lang="less">
.patient-edit-dialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}
.resetPatients {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-radio-button__inner {
    width: 100%;
    height: 46px;
    border-radius: 8px;
    line-height: 23px;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
<style scoped lang="less">
@import "../css/scroll.less";
@import "../assets/style/style.less";

@keyframes loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loadingWait {
  animation: loading 1.5s linear infinite;
  width: 24px;
  height: auto;
}

.imgWrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.similarDialog {
  .imgWrapper {
    align-items: flex-start;
    justify-content: space-between;
    font-size: 1.5rem;
    margin-top: 10vh;
    color: #48a3c2;
    padding-bottom: 30px;

    .chooseImgCon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      text-align: center;
      margin-right: 2%;

      .cs-text {
        margin-bottom: 2vh;
      }

      .imgBack {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 654px;
        height: 500px;
      }
    }

    .chooseImgCon:nth-child(2) {
      margin-right: 0px;
    }
  }
}

.mask {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.resilts {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.formWrapper,
.headTitle,
.leftIcon,
.formTitle,
.title,
.formItem {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.formWrapper {
  position: fixed;
  top: 10vh;
  left: 40%;
  width: 600px;
  height: 68%;
  border-radius: 10px;
  background: #ebebeb;

  .headTitle {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 17px;
    font-weight: bold;
    color: #61a2bf;
    width: 94%;
    margin-left: 3%;
    padding: 5px 0%;
    border-bottom: 2px solid #61a2bf;

    .leftIcon {
      flex-direction: row;
      align-items: center;
      white-space: nowrap;
      margin-left: 2%;
    }
  }

  .formTitle {
    width: 84%;
    padding: 10px 8%;

    .title {
      width: 100%;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    }

    .formItem {
      width: 100%;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.inline-label {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 1% 1%;
  font-weight: 600;

  .name {
    width: 68px;
    margin-right: 44%;
  }
}

.phoneCon {
  display: flex;
  flex-direction: row;
  margin-left: 1%;
  font-weight: 600;
}

.idAndname {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 20px;
  font-weight: 600;
  color: #000;

  .namecon {
    margin-right: 12vh;
    margin-bottom: 2vh;
  }

  .idcon {
    margin-bottom: 2vh;
  }
}

.confirm {
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  .comfirmBtn {
    cursor: pointer;
    width: 200px;
    height: 40px;
    border-radius: 10px;
    background: #61a2bf;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
  }
}
ul,
p {
  list-style: none;
  margin: 0;
  padding: 0;
}

.content {
  width: 100%;
  margin: 0 auto;
  position: relative;
  height: calc(~"100% - 90px");
}

.header {
  padding: 10px 2%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-shrink: 0;
  position: relative;
}

.patient-list {
  background: #fff;
  margin-left: 38px;
  margin-right: 38px;
  height: calc(~"100% - 60px");
}

.patient-list .list-header,
.list-content .list-item {
  display: flex;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ebebeb;
}

.patient-list span {
  text-align: center;
}

.list-header {
  color: #4aa3c4;
}

.noData {
  height: 160px;
  width: 100%;
  line-height: 120px;
  text-align: center;
  font-size: 24px;
  border-bottom: 1px solid #ebebeb;
  padding: 20px 40px;
  overflow: hidden;
  box-sizing: border-box;
}

.list-hid {
  width: 100%;
  padding: 20px 10px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.swiper-slide {
  display: flex;
}

.firstShow {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}
.cardImg {
  overflow: hidden;
  width: 110px !important;
  min-width: 110px !important;
  height: 110px !important;
}
.moreShow {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.check-box {
  cursor: pointer;
  width: 22%;
  // min-width: 412px;
  height: 100%;
  background: #ebebeb;
  border-radius: 20px;
  box-shadow: 5px 5px 5px #888888;
  float: left;
  margin: 10px 1.16%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;

  .card-type-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    z-index: 10;
    pointer-events: none;
  }

  .imgBack {
    width: 155px;
    height: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check-info {
    span {
      color: black;
    }
  }
}

.moreItem {
  width: 100%;
  margin-top: 1%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.getMore {
  margin-top: 20px;
  cursor: pointer;
  text-align: center;
  color: #4aa3c4;
  font-size: 15px;
}

.check-box .check-img {
  width: 120px;
  height: 93px;
  float: left;
  margin-right: 10px;
}

.checkBoxImg {
  width: 35%;
  height: auto;
}

.check-box .check-info {
  margin-left: 5%;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.check-info p {
  color: #4aa3c4;
  margin-bottom: 3px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-footer {
  text-align: right;
}

.detailed-info {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.el-dialog__wrapper::-webkit-scrollbar {
  display: none;
}

/*!*分页按钮*!
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;

  .current-page {
    color: @sColor;
    height: 40px;
    line-height: 40px;
    margin: 0 20px;
  }
}*/

.list-wrapper {
  position: absolute;
  left: 0;
  top: 50px;
  right: 0;
  bottom: 0;
  background-color: #ebebeb;
}

.el-collapse {
  height: calc(~"100% - 51px");
  overflow-y: auto;
}
.ellipsisP {
  flex: 1;
  display: flex;
  .ellipsisSpan {
    flex: 1;
    width: 1px;
    text-align: left;
  }
}
.space {
  flex: 1;
}
.createPatients {
  height: 36px;
}
.dialog {
  // min-width: 1205px;
  display: flex;
  align-items: center;
  .navBorder {
    width: 100%;
    height: 2px;
    background: #4da3c0;
  }
  .popTitleDialog {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  .popInput {
    width: 294px;
    border: 1px solid #c0c0c0 !important;
    border-radius: 8px;
    height: 48px;
    box-sizing: border-box;
  }
  .popInputSingle2 {
    width: 630px !important;
  }
  .leftItemSubmit2 {
    width: 298px;
    height: 42px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .isBW {
    display: flex;

    .isBWItem {
      flex: 1;
      font-size: 20px !important;
      font-weight: 600;
    }
    .activeBW {
      background: white;
      color: black;
    }
  }
}
#addpaintent {
  // display: flex;
  padding: 0 15px;
  box-sizing: border-box;
  .field-filled {
    /deep/ .el-input, /deep/ .el-textarea {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 4px;
        right: 4px;
        width: 8px;
        height: 8px;
        background: #4da2be;
        border-radius: 50%;
        z-index: 1;
        pointer-events: none;
      }
    }
    /deep/ .el-select {
      position: relative;
      /deep/ .el-input::after {
        display: none;
      }
      &::after {
        content: '';
        position: absolute;
        top: 4px;
        right: 25px;
        width: 8px;
        height: 8px;
        background: #4da2be;
        border-radius: 50%;
        z-index: 1;
        pointer-events: none;
      }
    }
  }
}
.heightAuto {
  width: 110px;
  height: auto;
}
.widthAuto {
  width: auto;
  height: 110px;
}
.check-box2 {
  width: 100%;
  display: flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.inHospitalCard p {
  color: #c59d69;
}
.baseline-badge {
  display: inline-block;
  background: #13ce66;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 6px;
  vertical-align: middle;
  letter-spacing: 1px;
}
.operation p {
  color: rgb(39, 101, 59);
}
.cosmetology {
  color: rgb(168, 66, 109) !important;
}
.tableTitle {
  cursor: pointer;
}

  .modify-btn:hover{
    color: #ff7979 !important;
  }
.el-pagination{
  text-align:-webkit-center;
  text-align:center;
  padding-top: 12px;
  padding-bottom: 8px;
  background-color: #fff;
}
.no_print{
  color: rgb(255,68,0);
}

.no_phone{
  color: rgb(255,68,0);
}
.online_report_regular{
  color: rgb(59, 212, 125);  
}
.online_report_note{
  color: rgb(90, 103, 247);  
}
.online_report_error{
  color: rgb(255, 27, 84)  
}

</style>


